(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  /* Hide footer group on 404 page */
  document.querySelectorAll('[class*="footer-group"]').forEach(function(el) {
    el.style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    document.querySelectorAll('.blog-listing').forEach(function (section) {
      var cursor = section.querySelector('.blog-listing__cursor');
      var cards = section.querySelectorAll('.blog-listing__featured, .blog-listing__card');
      if (!cursor || cards.length === 0) return;

      var targetX = 0, targetY = 0, currentX = 0, currentY = 0;
      var rafId = null, isOver = false, hideTimeout = null;

      function animate() {
        currentX += (targetX - currentX) * 0.15;
        currentY += (targetY - currentY) * 0.15;
        cursor.style.left = currentX + 'px';
        cursor.style.top = currentY + 'px';
        rafId = requestAnimationFrame(animate);
      }

      function show() {
        clearTimeout(hideTimeout);
        isOver = true;
        cursor.classList.add('is-visible');
        if (!rafId) rafId = requestAnimationFrame(animate);
      }

      function hide() {
        isOver = false;
        hideTimeout = setTimeout(function () {
          if (!isOver) {
            cursor.classList.remove('is-visible');
            if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
          }
        }, 50);
      }

      cards.forEach(function (card) {
        card.addEventListener('mouseenter', function (e) {
          if (!rafId) { currentX = e.clientX; currentY = e.clientY; }
          targetX = e.clientX;
          targetY = e.clientY;
          show();
        });
        card.addEventListener('mousemove', function (e) {
          targetX = e.clientX;
          targetY = e.clientY;
        });
        card.addEventListener('mouseleave', hide);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cal-embed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var iframes = document.querySelectorAll('iframe[data-fkcal]');
    if (!iframes.length) return;

    /* Warm the Cal connection up front so the DNS/TLS handshake is done before
       the embed fetches its script — shaves latency off the initial load. */
    ['https://app.cal.com', 'https://cal.com'].forEach(function (href) {
      if (document.head.querySelector('link[data-cal-preconnect="' + href + '"]')) return;
      var l = document.createElement('link');
      l.rel = 'preconnect';
      l.href = href;
      l.crossOrigin = 'anonymous';
      l.setAttribute('data-cal-preconnect', href);
      document.head.appendChild(l);
    });

    /* Mount after page load (NorthStar stores the visitor's click ids on a timer after its deferred script runs),
       so window.nsLead() is populated even on the very first landing. */
    function mountCal() {
    iframes.forEach(function (iframe) {
      if (iframe.__calInit) return;
      var calLink = iframe.getAttribute('data-fkcal-link');
      if (!calLink) return;
      iframe.__calInit = true;

      var origin = iframe.getAttribute('data-fkcal-origin') || 'https://app.cal.com';
      var ns = iframe.getAttribute('data-fkcal-namespace') || 'booking';
      var layout = iframe.getAttribute('data-fkcal-layout') || 'month_view';
      var theme = iframe.getAttribute('data-fkcal-theme') || 'light';
      var brand = iframe.getAttribute('data-fkcal-brand') || '';

      var cssVars = brand
        ? ',"cssVarsPerTheme":{"light":{"cal-brand":"' + brand + '"},"dark":{"cal-brand":"' + brand + '"}}'
        : '';

      /* NorthStar ad-click ids + UTMs (window.nsLead) as Cal booking metadata.
         Empty values are skipped; if nsLead is missing or throws, the embed is
         configured exactly as before. */
      var nsMetaCfg = '';
      try {
        if (typeof window.nsLead === 'function') {
          var ns = window.nsLead() || {};
          var nsMeta = {};
          ['gclid', 'fbclid', 'gbraid', 'wbraid', 'msclkid', 'ttclid'].forEach(function (k) { if (ns[k]) nsMeta['metadata[' + k + ']'] = ns[k]; });
          ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { if (ns.utm && ns.utm[k]) nsMeta['metadata[' + k + ']'] = ns.utm[k]; });
          ['ns_visitor', 'entry_landing_url'].forEach(function (k) { if (ns[k]) nsMeta['metadata[' + k + ']'] = ns[k]; });
          var nsJson = JSON.stringify(nsMeta);
          if (nsJson.length > 2) nsMetaCfg = ',' + nsJson.slice(1, -1).replace(/</g, '\\u003c');
        }
      } catch (nsErr) { nsMetaCfg = ''; }

      /* The isolated document that hosts Cal. Cal's official inline loader runs
         here, and a small bridge posts linkReady + bookingSuccessful to the
         parent (this page) so the parent can hide the loader and fire analytics. */
      var srcdoc =
        '<!doctype html><html><head><meta charset="utf-8">' +
        '<style>html,body{margin:0}#cal-mount{width:100%}</style></head>' +
        '<body><div id="cal-mount"></div><scr' + 'ipt>' +
        '(function (C, A, L) { var p = function (a, ar) { a.q.push(ar); }; var d = C.document; C.Cal = C.Cal || function () { var cal = C.Cal; var ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; } if (ar[0] === L) { var api = function () { p(api, arguments); }; var namespace = ar[1]; api.q = api.q || []; if (typeof namespace === "string") { cal.ns[namespace] = cal.ns[namespace] || api; p(cal.ns[namespace], ar); p(cal, ["initNamespace", namespace]); } else p(cal, ar); return; } p(cal, ar); }; })(window, "https://app.cal.com/embed/embed.js", "init");' +
        'Cal("init", "' + ns + '", {origin:"' + origin + '"});' +
        'Cal.ns["' + ns + '"]("inline", { elementOrSelector: "#cal-mount", config: {"layout":"' + layout + '","theme":"' + theme + '","useSlotsViewOnSmallScreen":true' + nsMetaCfg + '}, calLink: "' + calLink + '" });' +
        'Cal.ns["' + ns + '"]("ui", {"theme":"' + theme + '","hideEventTypeDetails":false,"layout":"' + layout + '"' + cssVars + '});' +
        /* Report the real content height so the parent can size the iframe to it
           (no dead space, adapts if the layout changes). */
        'var __postH=function(){ try{ parent.postMessage({fkcal:"height", height: document.documentElement.scrollHeight}, "*"); }catch(_){} };' +
        'if (window.ResizeObserver){ new ResizeObserver(__postH).observe(document.body); } window.addEventListener("load", __postH);' +
        'Cal.ns["' + ns + '"]("on", { action: "linkReady", callback: function(){ parent.postMessage({fkcal:"ready"}, "*"); __postH(); } });' +
        'Cal.ns["' + ns + '"]("on", { action: "bookingSuccessful", callback: function(e){ var dt=(e&&e.detail&&e.detail.data)||{}; parent.postMessage({fkcal:"booked", data:dt}, "*"); } });' +
        '</scr' + 'ipt></body></html>';

      iframe.srcdoc = srcdoc;
    });
    }
    if (document.readyState === 'complete') mountCal();
    else window.addEventListener('load', function () { setTimeout(mountCal, 0); });

    /* Parent bridge: hide the loader when Cal is ready, and forward a confirmed
       booking to analytics (Echelonn subscribes to 'echelonn:booking_confirmed'). */
    window.addEventListener('message', function (e) {
      var msg = e && e.data;
      if (!msg || typeof msg !== 'object') return;

      if (msg.fkcal === 'ready') {
        document.querySelectorAll('.cal-embed__frame').forEach(function (f) { f.classList.add('is-loaded'); });
        return;
      }

      if (msg.fkcal === 'height') {
        var h = parseInt(msg.height, 10);
        if (!h) return;
        h = Math.min(Math.max(h, 300), 1200); /* sane bounds */
        for (var i = 0; i < iframes.length; i++) {
          if (iframes[i].contentWindow === e.source) { iframes[i].style.height = h + 'px'; break; }
        }
        return;
      }

      if (msg.fkcal === 'booked') {
        /* Only trust a booking message that actually came from one of our own Cal
           iframes. The height branch above already checks e.source; this one did
           not, so any page or embed could post a fake {fkcal:'booked'} and fire a
           bogus conversion. That matters more now that this path forwards an email
           address to a third-party pixel. */
        var fromOurFrame = false;
        for (var k = 0; k < iframes.length; k++) {
          if (iframes[k].contentWindow === e.source) { fromOurFrame = true; break; }
        }
        if (!fromOurFrame) return;

        try {
          var d = msg.data || {};
          var payload = { source: 'cal-inline' };
          if (d.booking && d.booking.uid) payload.booking_uid = d.booking.uid;
          if (d.eventType && d.eventType.slug) payload.event_type = d.eventType.slug;

          /* Koast/Whop: a confirmed call is their "schedule" funnel event.
             Cal reports the attendee under attendees[] on newer versions and
             responses.email on older ones, where the value can be either a bare
             string or a {value: ...} object — read all three shapes rather than
             assuming one. Guarded on window.whop: the loader is skipped in the
             theme editor, so the global is absent there. */
          try {
            if (window.whop) {
              var att = (d.booking && d.booking.attendees && d.booking.attendees[0]) || {};
              var resp = (d.booking && d.booking.responses && d.booking.responses.email) || '';
              if (resp && typeof resp === 'object') resp = resp.value || '';
              var calEmail = (att.email || resp || '').toString().trim().toLowerCase();
              if (calEmail && window.fkWhopIdentify) fkWhopIdentify(calEmail);
              whop.track('schedule');
            }
          } catch (werr) {
            if (window.console) console.error('Whop schedule event failed:', werr);
          }
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('echelonn:booking_confirmed', payload);
          }
          if (window.dataLayer && typeof window.dataLayer.push === 'function') {
            window.dataLayer.push({ event: 'booking_confirmed', booking: payload });
          }
          document.dispatchEvent(new CustomEvent('fk:booking-confirmed', { detail: payload }));
        } catch (err) { if (window.console) console.error('Cal booking event failed:', err); }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var backdrop = document.querySelector('[data-cart-backdrop]');
    var SECTION_ID = 'cart-drawer';
    var changeUrl = drawer.getAttribute('data-cart-change-url') || '/cart/change';
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.classList.add('is-visible');
      window.fkScrollLock.lock('cart');
      var closeBtn = drawer.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (backdrop) backdrop.classList.remove('is-visible');
      window.fkScrollLock.unlock('cart');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function swapBody(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newBody = doc.querySelector('[data-cart-drawer-body]');
      var newCount = doc.querySelector('.cart-drawer__count');
      var curBody = drawer.querySelector('[data-cart-drawer-body]');
      if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;
      if (newCount) {
        var curCount = drawer.querySelector('.cart-drawer__count');
        if (curCount) curCount.textContent = newCount.textContent;
      }
      updateHeaderCount(doc);
    }

    function updateHeaderCount(doc) {
      /* Pull the fresh item count from the re-rendered section's count text */
      var countEl = drawer.querySelector('.cart-drawer__count');
      var n = countEl ? parseInt(countEl.textContent, 10) : null;
      if (n === null || isNaN(n)) return;
      var headerCount = document.querySelector('.header__cart-count');
      if (headerCount) headerCount.textContent = '' + n;
    }

    function fetchSection() {
      return fetch(window.location.pathname + '?section_id=' + SECTION_ID)
        .then(function (r) { return r.text(); });
    }

    function refresh() {
      return fetchSection().then(swapBody);
    }

    function changeLine(key, quantity) {
      drawer.classList.add('is-loading');
      return fetch(changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: [SECTION_ID] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections && data.sections[SECTION_ID]) {
            swapBody(data.sections[SECTION_ID]);
          } else {
            return refresh();
          }
        })
        .catch(function () { return refresh(); })
        .then(function () { drawer.classList.remove('is-loading'); });
    }

    /* Delegated clicks inside the drawer */
    drawer.addEventListener('click', function (e) {
      var changeBtn = e.target.closest('[data-qty-change]');
      if (changeBtn) {
        var keyHolder = changeBtn.closest('[data-line-key]');
        var key = keyHolder ? keyHolder.getAttribute('data-line-key') : changeBtn.getAttribute('data-line-key');
        var qty = parseInt(changeBtn.getAttribute('data-qty-change'), 10);
        if (key && !isNaN(qty)) changeLine(key, qty);
        return;
      }
      if (e.target.closest('[data-cart-close]')) {
        close();
      }
    });

    if (backdrop) backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    /* Open from any [data-open="cart"] trigger (header icon) */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-open="cart"]');
      if (trigger) { e.preventDefault(); open(); }
    });

    /* Global API for product forms + header */
    window.fkCartDrawer = { open: open, close: close, refresh: refresh };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    var sectionId = page.getAttribute('data-section-id');
    var changeUrl = page.getAttribute('data-cart-change-url') || '/cart/change';

    function swapRoot(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-root]');
      var cur = page.querySelector('[data-cart-root]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      updateHeaderCount(doc);
    }

    function updateHeaderCount(doc) {
      var freshCount = doc.querySelector('.cart-page__count');
      var n = freshCount ? parseInt(freshCount.textContent, 10) : null;
      if (n === null || isNaN(n)) n = 0;
      var headerCount = document.querySelector('.header__cart-count');
      if (headerCount) headerCount.textContent = '' + n;
    }

    function changeLine(key, quantity) {
      page.classList.add('is-loading');
      fetch(changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: [sectionId] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections && data.sections[sectionId]) {
            swapRoot(data.sections[sectionId]);
          } else {
            return fetch(window.location.pathname + '?section_id=' + sectionId)
              .then(function (r) { return r.text(); })
              .then(swapRoot);
          }
        })
        .catch(function () {})
        .then(function () { page.classList.remove('is-loading'); });
    }

    page.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var holder = btn.closest('[data-line-key]') || btn;
      var key = holder.getAttribute('data-line-key');
      var qty = parseInt(btn.getAttribute('data-qty-change'), 10);
      if (key && !isNaN(qty)) changeLine(key, qty);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-studies-listing"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.cs-index');
    if (!section) return;

    var list = section.querySelector('[data-cs-index-grid]');
    var rows = section.querySelectorAll('[data-cs-index-item]');
    if (!list || !rows.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });

    list.classList.add('is-reveal-ready');
    rows.forEach(function(row) { observer.observe(row); });
  })();

  (function() {
    var section = document.querySelector('.cs-index');
    if (!section) return;

    var cursor = section.querySelector('.cs-index__cursor');
    var links = section.querySelectorAll('.cs-index__link');
    if (!cursor || !links.length) return;
    if (!window.matchMedia('(hover: hover)').matches) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targetX = 0;
    var targetY = 0;
    var currentX = 0;
    var currentY = 0;
    var rafId = null;
    var hideTimeout = null;

    function place() {
      cursor.style.left = currentX + 'px';
      cursor.style.top = currentY + 'px';
    }

    function animate() {
      currentX += (targetX - currentX) * 0.18;
      currentY += (targetY - currentY) * 0.18;
      place();
      rafId = requestAnimationFrame(animate);
    }

    function stop() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    }

    var rows = Array.prototype.map.call(links, function(link) { return link.parentElement; });

    function setRipple(hoveredIndex) {
      rows.forEach(function(row, i) {
        row.style.setProperty('--cs-d', Math.abs(i - hoveredIndex));
      });
    }

    links.forEach(function(link, index) {
      link.addEventListener('mouseenter', function(e) {
        setRipple(index);
        clearTimeout(hideTimeout);
        targetX = e.clientX;
        targetY = e.clientY;
        if (!cursor.classList.contains('is-visible')) {
          currentX = targetX;
          currentY = targetY;
          place();
        }
        cursor.classList.add('is-visible');
        if (!reduceMotion && !rafId) rafId = requestAnimationFrame(animate);
      });

      link.addEventListener('mousemove', function(e) {
        targetX = e.clientX;
        targetY = e.clientY;
        if (reduceMotion) {
          currentX = targetX;
          currentY = targetY;
          place();
        }
      });

      /* A short grace period so moving between rows doesn't flicker the
         label off and on. */
      link.addEventListener('mouseleave', function() {
        hideTimeout = setTimeout(function() {
          cursor.classList.remove('is-visible');
          stop();
        }, 50);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-study-body"]) return;
  try {
    
  (function() {
    var groups = document.querySelectorAll('.cs-body [data-cs-reveal-group]');
    if (!groups.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var STAGGER = 140;
    var nextAt = 0;

    /* Hand out start times at least STAGGER ms apart. Photos that enter
       together (a row of both columns, or a fast scroll) cascade; a lone
       photo entering after a pause starts immediately. */
    function reveal(el) {
      var now = performance.now();
      var at = Math.max(now, nextAt);
      nextAt = at + STAGGER;
      el.style.setProperty('--cs-delay', Math.round(at - now) + 'ms');
      el.classList.add('is-revealed');
    }

    var observer = new IntersectionObserver(function(entries) {
      entries
        .filter(function(entry) { return entry.isIntersecting; })
        .sort(function(a, b) {
          return (a.boundingClientRect.top - b.boundingClientRect.top) ||
            (a.boundingClientRect.left - b.boundingClientRect.left);
        })
        .forEach(function(entry) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
    }, { rootMargin: '0px 0px -20% 0px' });

    groups.forEach(function(group) {
      group.classList.add('is-reveal-ready');
      group.querySelectorAll('[data-cs-reveal]').forEach(function(item) {
        observer.observe(item);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["confirmation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var params = new URLSearchParams(window.location.search);
    var design = window.Shopify && window.Shopify.designMode;

    /* Cal.com sends startTime/endTime as ISO 8601 UTC (e.g. 2024-01-15T14:00:00.000Z).
       Parse and render in the visitor's local time; fall back to raw if not a date. */
    function format(raw, kind) {
      if (!kind || kind === 'text') return raw;
      var d = new Date(raw);
      if (isNaN(d.getTime())) return raw;
      if (kind === 'date') {
        return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
      }
      if (kind === 'time') {
        return d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
      }
      if (kind === 'datetime') {
        return d.toLocaleString(undefined, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' });
      }
      return raw;
    }

    document.querySelectorAll('[data-confirmation-details]').forEach(function (panel) {
      var anyShown = false;

      panel.querySelectorAll('.confirmation__detail').forEach(function (row) {
        var key = row.getAttribute('data-param');
        var kind = row.getAttribute('data-format');
        var raw = key ? params.get(key) : null;
        var valEl = row.querySelector('[data-detail-value]');
        if (!valEl) return;

        if (raw && raw.trim()) {
          valEl.textContent = format(raw.trim(), kind); /* textContent — no HTML injection */
          anyShown = true;
        } else if (valEl.textContent.trim()) {
          anyShown = true; /* editor-set fallback value */
        } else if (design) {
          valEl.textContent = '—';
          anyShown = true;
        } else {
          row.hidden = true;
        }
      });

      if (!anyShown) panel.hidden = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-consent"]) return;
  try {
    
  var banner = document.getElementById('cookie-consent');
  if (!banner) return;

  var COOKIE_KEY = 'fk_cookie_consent';

  /* Already consented — don't show */
  if (document.cookie.indexOf(COOKIE_KEY + '=') !== -1) return;

  /* Show banner */
  banner.style.display = '';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (typeof gsap !== 'undefined' && !prefersReducedMotion) {
    gsap.fromTo(banner, { autoAlpha: 0, y: 12 }, { autoAlpha: 1, y: 0, duration: 0.4, delay: 1.5, ease: 'power2.out' });
  }

  function setCookie(value) {
    var d = new Date();
    d.setFullYear(d.getFullYear() + 1);
    document.cookie = COOKIE_KEY + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function dismiss() {
    if (typeof gsap !== 'undefined' && !prefersReducedMotion) {
      gsap.to(banner, {
        autoAlpha: 0, y: 12, duration: 0.3, ease: 'power2.in',
        onComplete: function() { banner.hidden = true; }
      });
    } else {
      banner.style.display = 'none';
    }
  }

  banner.querySelector('[data-cookie-accept]').addEventListener('click', function() {
    setCookie('accepted');
    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent(true, function() {});
    }
    dismiss();
  });

  banner.querySelector('[data-cookie-decline]').addEventListener('click', function() {
    setCookie('declined');
    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent(false, function() {});
    }
    dismiss();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 350;

    function closeItem(item) {
      if (!item.open || item.classList.contains('is-closing')) return;
      item.classList.add('is-closing');
      setTimeout(function () {
        item.open = false;
        item.classList.remove('is-closing');
      }, DURATION);
    }

    function openItem(item) {
      item.classList.remove('is-closing');
      item.open = true;
    }

    document.querySelectorAll('.faq-page').forEach(function (page) {
      var items = page.querySelectorAll('.faq-page__item');

      items.forEach(function (item) {
        var summary = item.querySelector('.faq-page__question');
        if (!summary) return;

        summary.addEventListener('click', function (e) {
          e.preventDefault();

          if (item.open && !item.classList.contains('is-closing')) {
            closeItem(item);
            return;
          }

          items.forEach(function (other) {
            if (other !== item && other.open) closeItem(other);
          });
          openItem(item);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  var DURATION = 350;

  function closeItem(item) {
    if (!item.open || item.classList.contains('is-closing')) return;
    item.classList.add('is-closing');
    setTimeout(function() {
      item.open = false;
      item.classList.remove('is-closing');
    }, DURATION);
  }

  function openItem(item) {
    item.classList.remove('is-closing');
    item.open = true;
  }

  var faqItems = document.querySelectorAll('.faq__item');

  faqItems.forEach(function(item) {
    var summary = item.querySelector('.faq__question');

    summary.addEventListener('click', function(e) {
      e.preventDefault();

      var parentSection = item.closest('.faq');
      var siblings = parentSection.querySelectorAll('.faq__item');

      if (item.open && !item.classList.contains('is-closing')) {
        closeItem(item);
      } else {
        siblings.forEach(function(other) {
          if (other !== item && other.open) closeItem(other);
        });
        openItem(item);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    /* Live viewport check — a one-time boolean goes stale when the page loads
       wide (theme-editor preview, responsive DevTools) and is then viewed at
       mobile width, leaving aria-expanded out of sync with the CSS-collapsed
       body. That desync is what made the first tap a no-op. */
    var mq = window.matchMedia('(max-width: 768px)');

    document.querySelectorAll('.footer .footer__column-heading').forEach(function(btn) {
      var body = btn.nextElementSibling;
      if (!body || !body.classList.contains('footer__column-body')) return;

      function collapse() {
        body.style.height = body.scrollHeight + 'px';
        requestAnimationFrame(function() {
          body.style.height = '0px';
        });
        btn.setAttribute('aria-expanded', 'false');
      }

      function expand() {
        body.style.height = body.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
        body.addEventListener('transitionend', function handler() {
          body.removeEventListener('transitionend', handler);
          if (btn.getAttribute('aria-expanded') === 'true') {
            body.style.height = 'auto';
          }
        });
      }

      /* Keep aria state and inline height in lockstep with the active breakpoint.
         Mobile → collapsed by default; desktop → always open with no inline
         height (CSS shows it). Runs on load and on every breakpoint change. */
      function syncToViewport() {
        if (mq.matches) {
          btn.setAttribute('aria-expanded', 'false');
          body.style.height = '0px';
        } else {
          btn.setAttribute('aria-expanded', 'true');
          body.style.height = '';
        }
      }

      syncToViewport();
      if (mq.addEventListener) {
        mq.addEventListener('change', syncToViewport);
      } else {
        mq.addListener(syncToViewport);
      }

      btn.addEventListener('click', function() {
        if (!mq.matches) return;
        if (btn.getAttribute('aria-expanded') === 'true') {
          collapse();
        } else {
          expand();
        }
      });
    });

    /* Newsletter signup → AJAX so it never does Shopify's native /contact POST
       (which reloads the page to ?contact_posted=true#contact_form and yanks the
       visitor down to the footer). Submit in the background, show an inline note. */
    document.querySelectorAll('.footer__newsletter-form').forEach(function(form, idx) {
      var wrap = form.closest('.footer__newsletter-content');
      var message = wrap ? wrap.querySelector('[data-newsletter-message]') : null;
      var submitBtn = form.querySelector('button[type="submit"]');

      function showMessage(text, isError) {
        if (!message) return;
        message.textContent = text;
        message.hidden = false;
        message.classList.toggle('footer__newsletter-message--error', !!isError);
      }

      /* Submit NATIVELY into a hidden iframe. Two reasons:
         1. Shopify's spam-protection reCAPTCHA only attaches its token on a real
            form submission — an AJAX fetch is rejected with 400 "Missing CAPTCHA
            token". A native submit lets Shopify add the token.
         2. The iframe target keeps the visitor on the page instead of navigating
            to /contact (there is no /contact page). */
      var sink = document.createElement('iframe');
      sink.name = 'fk-newsletter-sink-' + idx;
      sink.setAttribute('aria-hidden', 'true');
      sink.tabIndex = -1;
      sink.style.cssText = 'position:absolute;left:-9999px;width:0;height:0;border:0;';
      document.body.appendChild(sink);
      form.setAttribute('target', sink.name);

      var pending = false;
      form.addEventListener('submit', function() {
        pending = true;
        if (submitBtn) submitBtn.disabled = true;
      });

      sink.addEventListener('load', function() {
        if (!pending) return; /* ignore the iframe's initial blank load */
        pending = false;
        if (submitBtn) submitBtn.disabled = false;
        var ok = true;
        try {
          /* Success redirects back to the page (…?customer_posted=true); a failure
             re-renders /contact. Same origin, so the URL is readable. */
          if (sink.contentWindow.location.pathname.indexOf('/contact') === 0) ok = false;
        } catch (e) { /* unreadable → assume success */ }
        if (ok) {
          form.reset();
          showMessage(wrap ? wrap.getAttribute('data-newsletter-success') : '', false);
        } else {
          showMessage(wrap ? wrap.getAttribute('data-newsletter-error') : '', true);
        }
        sink.src = 'about:blank'; /* unload the page we pulled into the iframe */
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-section"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    /* 1 original + 4 clones. Start in the CENTER set so there's a full 2 sets of
       buffer to scroll into either way before hitting an edge. Clones are
       identical, so re-centering (normalize) is visually seamless. */
    var SETS = 5, CENTER = 2;

    document.querySelectorAll('.gallery-section__gallery').forEach(function(gallery) {
      var track = gallery.querySelector('.gallery-section__track');
      if (!track) return;

      var items = track.querySelectorAll('.gallery-section__item');
      if (items.length === 0) return;

      var gap = 8;
      var originalWidth = 0;
      items.forEach(function(item) { originalWidth += item.offsetWidth + gap; });

      for (var s = 1; s < SETS; s++) {
        items.forEach(function(item) {
          var clone = item.cloneNode(true);
          clone.removeAttribute('data-shopify-editor-block');
          track.appendChild(clone);
        });
      }

      /* Start in the center set — buffer both directions. */
      track.scrollLeft = CENTER * originalWidth;

      var autoScrollId = null;
      /* Float accumulator — iOS rounds scrollLeft to an integer, so `+= 0.5`
         read back from the DOM never advances. We keep our own position. */
      var scrollPos = track.scrollLeft;
      var paused = false;      /* auto-scroll suspended (user interacting or settling) */
      var interacting = false; /* a finger or mouse button is currently down */
      var dragging = false;    /* mouse click-drag in progress */
      var touching = false;    /* touch gesture in progress (mobile) */
      var inView = false;
      var resumeTimer = null;
      var lastLeft = -1;       /* last integer scrollLeft written — skip redundant writes */

      /* Re-center into the center set. Clones are identical, so shifting by whole
         set-widths is invisible. Safe any time EXCEPT mid-touch-fling (writing
         scrollLeft then kills iOS momentum), so callers guard with `touching`. */
      function normalize() {
        var x = track.scrollLeft;
        while (x >= (CENTER + 1) * originalWidth) x -= originalWidth;
        while (x < CENTER * originalWidth) x += originalWidth;
        if (x !== track.scrollLeft) track.scrollLeft = x;
        scrollPos = track.scrollLeft;
      }

      function tick() {
        scrollPos += 0.75; /* px per frame (~45px/s at 60fps) */
        if (scrollPos >= (CENTER + 1) * originalWidth) scrollPos -= originalWidth;
        /* scrollLeft rounds to whole pixels, so some frames are redundant —
           only write when the integer position actually changes. */
        var next = Math.round(scrollPos);
        if (next !== lastLeft) { track.scrollLeft = next; lastLeft = next; }
        autoScrollId = requestAnimationFrame(tick);
      }

      function startAutoScroll() {
        if (prefersReducedMotion || autoScrollId || paused || interacting || !inView) return;
        scrollPos = track.scrollLeft; /* sync to wherever we are now */
        autoScrollId = requestAnimationFrame(tick);
      }

      function stopAutoScroll() {
        if (autoScrollId) { cancelAnimationFrame(autoScrollId); autoScrollId = null; }
      }

      function scheduleResume() {
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function() {
          resumeTimer = null;
          if (interacting) return;
          paused = false;
          normalize();
          startAutoScroll();
        }, 800);
      }

      /* Users can scrub the gallery themselves — touch swipe, trackpad/shift-wheel,
         or click-drag. The auto-scroll pauses the moment they interact and resumes
         once they've been idle. We key off the INPUT events (not the scroll
         position), so the loop's own scrollLeft writes are never mistaken for user
         input — that ambiguity was the old jam. `interacting` is true while a
         finger or mouse button is down. */
      function pauseNow() {
        paused = true;
        stopAutoScroll();
        if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
      }

      /* Touch (mobile): pause on contact, resume after the fling settles. */
      track.addEventListener('touchstart', function() { touching = true; interacting = true; pauseNow(); }, { passive: true });
      var onTouchDone = function() { touching = false; interacting = false; scheduleResume(); };
      track.addEventListener('touchend', onTouchDone, { passive: true });
      track.addEventListener('touchcancel', onTouchDone, { passive: true });

      /* Horizontal wheel / shift-wheel / trackpad. Ignore vertical-intent wheels
         so scrolling the PAGE past the gallery doesn't pause it. */
      track.addEventListener('wheel', function(e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        pauseNow();
        scheduleResume();
      }, { passive: true });

      /* Mouse click-drag to scrub (desktop). Touch is handled above. */
      var startX = 0, startScroll = 0;
      track.addEventListener('pointerdown', function(e) {
        if (e.pointerType === 'touch') return;
        dragging = true;
        interacting = true;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        pauseNow();
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', function(e) {
        if (!dragging) return;
        track.scrollLeft = startScroll - (e.clientX - startX);
      });
      var endDrag = function() {
        if (!dragging) return;
        dragging = false;
        interacting = false;
        track.classList.remove('is-dragging');
        normalize(); /* invisible re-center so the next drag has full buffer */
        scheduleResume();
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      /* Inertia keeps firing scroll events after a gesture; each pushes the
         resume back so we only restart once movement fully stops. Guarded by
         `paused` so the auto-scroll's own writes are ignored. */
      track.addEventListener('scroll', function() {
        if (paused && !interacting) scheduleResume();
      }, { passive: true });

      var observer = new IntersectionObserver(function(entries) {
        inView = entries[0].isIntersecting;
        if (inView) startAutoScroll();
        else stopAutoScroll();
      }, { threshold: 0.2 });

      observer.observe(gallery);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    var wrap = header.querySelector('[data-header-wrap]');
    var pill = header.querySelector('[data-header-pill]');
    var links = header.querySelector('[data-header-links]');
    var pop = header.querySelector('[data-header-pop]');
    var triggers = Array.prototype.slice.call(header.querySelectorAll('[data-header-trigger]'));
    var panes = {};
    header.querySelectorAll('[data-header-pane]').forEach(function(pane) {
      panes[pane.getAttribute('data-header-pane')] = pane;
    });
    var desktop = window.matchMedia('(min-width: 1025px)');

    /* ── The gliding chip ──
       Sits under the hovered link. With nothing hovered it goes to the open
       panel's trigger, else the current page (aria-current), else fades out. */
    var hovered = null;
    var chipHiddenAt = 0;

    function chipTo(el) {
      var lr = links.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      /* Only appear in place when the chip has fully faded; if it's still
         fading out, slide it from where it is instead of jumping. */
      var fresh = !links.classList.contains('has-chip') && Date.now() - chipHiddenAt > 300;
      if (fresh) links.classList.add('chip-fresh');
      links.style.setProperty('--hx', (r.left - lr.left) + 'px');
      links.style.setProperty('--hw', r.width + 'px');
      if (fresh) {
        void links.offsetWidth;
        links.classList.remove('chip-fresh');
      }
      links.classList.add('has-chip');
    }

    function chipRest() {
      var target = hovered ||
        links.querySelector('[aria-expanded="true"]') ||
        links.querySelector('[aria-current]');
      if (target) {
        chipTo(target);
      } else if (links.classList.contains('has-chip')) {
        links.classList.remove('has-chip');
        chipHiddenAt = Date.now();
      }
    }

    links.querySelectorAll('.site-header__link').forEach(function(link) {
      link.addEventListener('pointerenter', function(e) {
        if (e.pointerType !== 'mouse') return;
        hovered = link;
        chipTo(link);
      });
      link.addEventListener('focus', function() { chipTo(link); });
    });
    links.addEventListener('pointerleave', function() {
      hovered = null;
      chipRest();
    });
    links.addEventListener('focusout', function(e) {
      if (!links.contains(e.relatedTarget) && !header.classList.contains('is-open')) chipRest();
    });

    /* ── Desktop dropdowns ──
       One surface under the pill. Opening places it under its trigger (kept
       inside the pill's span); switching between Industries and Work with us
       reshapes it in place. Opens on hover (mouse) or click; closes on leave,
       outside click, Escape or focus leaving the header. */
    var timer;

    function place(name) {
      var trigger = header.querySelector('[data-header-trigger="' + name + '"]');
      var pane = panes[name];
      var wr = wrap.getBoundingClientRect();
      var tr = trigger.getBoundingClientRect();
      var w = pane.offsetWidth;
      var h = pane.offsetHeight;
      var x = tr.left + tr.width / 2 - w / 2 - wr.left;
      x = Math.max(0, Math.min(x, wr.width - w));
      pop.style.setProperty('--pw', w + 'px');
      pop.style.setProperty('--ph', h + 'px');
      pop.style.setProperty('--px', x + 'px');
      pop.style.setProperty('--po', (tr.left + tr.width / 2 - wr.left - x) + 'px');
      return trigger;
    }

    function show(name) {
      clearTimeout(timer);
      if (!panes[name]) return;
      var wasOpen = header.classList.contains('is-open');
      header.classList.toggle('is-morphing', wasOpen);
      var trigger = place(name);
      Object.keys(panes).forEach(function(key) {
        panes[key].classList.toggle('is-on', key === name);
        if (key !== name) panes[key].classList.remove('has-hl');
      });
      triggers.forEach(function(t) { t.setAttribute('aria-expanded', t === trigger ? 'true' : 'false'); });
      header.setAttribute('data-pane', name);
      header.classList.remove('is-hidden');
      header.classList.add('is-open');
      chipRest();
    }

    function hide(delay) {
      clearTimeout(timer);
      timer = setTimeout(function() {
        header.classList.remove('is-open', 'is-morphing');
        header.removeAttribute('data-pane');
        Object.keys(panes).forEach(function(key) { panes[key].classList.remove('is-on'); });
        triggers.forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
        chipRest();
      }, delay || 0);
    }

    triggers.forEach(function(trigger) {
      var name = trigger.getAttribute('data-header-trigger');
      trigger.addEventListener('pointerenter', function(e) {
        if (e.pointerType !== 'mouse' || !desktop.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function() { show(name); }, header.classList.contains('is-open') ? 0 : 90);
      });
      /* Sweeping across a closed trigger shouldn't open it. */
      trigger.addEventListener('pointerleave', function(e) {
        if (e.pointerType === 'mouse' && !header.classList.contains('is-open')) clearTimeout(timer);
      });
      trigger.addEventListener('click', function() {
        if (header.getAttribute('data-pane') === name) hide(0);
        else show(name);
      });
      trigger.addEventListener('keydown', function(e) {
        if (e.key !== 'ArrowDown') return;
        e.preventDefault();
        show(name);
        var first = panes[name] && panes[name].querySelector('a, button');
        if (first) setTimeout(function() { first.focus(); }, 60);
      });
    });

    /* Resting on a plain link closes an open panel. The delay leaves time to
       cut across a neighbouring link on the way down into the panel. */
    links.querySelectorAll('.site-header__link:not([data-header-trigger])').forEach(function(link) {
      link.addEventListener('pointerenter', function(e) {
        if (e.pointerType === 'mouse' && header.classList.contains('is-open')) hide(260);
      });
    });
    /* Reaching the panel keeps it open and hands the chip back to its trigger. */
    pop.addEventListener('pointerenter', function() {
      clearTimeout(timer);
      hovered = null;
      chipRest();
    });
    wrap.addEventListener('pointerleave', function(e) {
      if (e.pointerType === 'mouse' && header.classList.contains('is-open')) hide(220);
    });
    wrap.addEventListener('pointerenter', function() {
      if (header.classList.contains('is-open')) clearTimeout(timer);
    });
    header.addEventListener('focusout', function(e) {
      if (header.classList.contains('is-open') && !wrap.contains(e.relatedTarget)) hide(0);
    });
    document.addEventListener('click', function(e) {
      if (header.classList.contains('is-open') && !wrap.contains(e.target)) hide(0);
    });
    /* ── Row highlight inside each pane ──
       Follows the pointer (or focus) from row to row and only fades when the
       pointer leaves the pane. offsetLeft/Top are layout values, so the
       panel's own scale/slide animation doesn't throw the position off. */
    Object.keys(panes).forEach(function(key) {
      var pane = panes[key];
      var hl = pane.querySelector('.site-header__hl');
      if (!hl) return;

      function hlTo(item) {
        var fresh = !pane.classList.contains('has-hl');
        if (fresh) pane.classList.add('hl-fresh');
        pane.style.setProperty('--rx', item.offsetLeft + 'px');
        pane.style.setProperty('--ry', item.offsetTop + 'px');
        pane.style.setProperty('--rw', item.offsetWidth + 'px');
        pane.style.setProperty('--rh', item.offsetHeight + 'px');
        if (fresh) {
          void pane.offsetWidth;
          pane.classList.remove('hl-fresh');
        }
        pane.classList.add('has-hl');
      }

      function itemFrom(target) {
        var item = target.closest && target.closest('.site-header__item');
        return item && pane.contains(item) ? item : null;
      }

      pane.addEventListener('pointerover', function(e) {
        var item = itemFrom(e.target);
        if (item) hlTo(item);
      });
      pane.addEventListener('pointerleave', function() { pane.classList.remove('has-hl'); });
      pane.addEventListener('focusin', function(e) {
        var item = itemFrom(e.target);
        if (item) hlTo(item);
      });
      pane.addEventListener('focusout', function(e) {
        if (!pane.contains(e.relatedTarget)) pane.classList.remove('has-hl');
      });
    });

    /* Rows that stay on the page (quote modal, phone) close the panel. */
    pop.querySelectorAll('[data-open="quote-modal"], a[href^="tel:"]').forEach(function(el) {
      el.addEventListener('click', function() { hide(0); });
    });

    /* ── Mobile menu: the pill grows into a sheet ── */
    var toggle = header.querySelector('[data-header-toggle]');
    var sheet = header.querySelector('[data-header-sheet]');
    var row = header.querySelector('.site-header__row');

    function menuOpen() {
      return header.hasAttribute('data-menu-open');
    }

    function sizeSheet() {
      var top = wrap.getBoundingClientRect().top;
      var max = window.innerHeight - top * 2;
      var want = row.offsetHeight + sheet.scrollHeight;
      pill.style.setProperty('--sheet-h', Math.min(want, max) + 'px');
    }

    function setMenu(open) {
      if (open) {
        header.classList.remove('is-hidden');
        sizeSheet();
        header.setAttribute('data-menu-open', '');
      } else {
        header.removeAttribute('data-menu-open');
        sheet.scrollTop = 0;
      }
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }

    toggle.addEventListener('click', function() { setMenu(!menuOpen()); });
    header.querySelector('[data-header-scrim]').addEventListener('click', function() { setMenu(false); });

    sheet.querySelectorAll('[data-header-group]').forEach(function(button) {
      var group = document.getElementById(button.getAttribute('aria-controls'));
      button.addEventListener('click', function() {
        var open = !group.classList.contains('is-open');
        group.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        /* Grow or shrink the pill along with the group. The group hasn't
           moved yet, so add or take away its full content height. */
        var change = group.firstElementChild.scrollHeight * (open ? 1 : -1);
        var max = window.innerHeight - wrap.getBoundingClientRect().top * 2;
        pill.style.setProperty('--sheet-h', Math.min(row.offsetHeight + sheet.scrollHeight + change, max) + 'px');
      });
    });

    sheet.addEventListener('click', function(e) {
      if (e.target.closest('a, [data-open="quote-modal"]')) setMenu(false);
    });

    function onBreakpoint() {
      if (desktop.matches && menuOpen()) setMenu(false);
      if (!desktop.matches && header.classList.contains('is-open')) hide(0);
    }
    if (desktop.addEventListener) desktop.addEventListener('change', onBreakpoint);
    window.addEventListener('resize', function() { if (menuOpen()) sizeSheet(); });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      if (menuOpen()) {
        setMenu(false);
        toggle.focus();
      } else if (header.classList.contains('is-open')) {
        var open = header.querySelector('[data-header-trigger][aria-expanded="true"]');
        hide(0);
        if (open) open.focus();
      }
    });

    /* ── Scroll: tighten once off the top; hide going down, back going up ── */
    var lastY = window.scrollY;
    var ticking = false;

    function onScroll() {
      ticking = false;
      var y = window.scrollY;
      header.classList.toggle('is-compact', desktop.matches && y > 40);

      /* Stay put while a panel or the menu is open. */
      if (menuOpen() || header.classList.contains('is-open') || y < window.innerHeight * 0.5) {
        header.classList.remove('is-hidden');
        lastY = y;
        return;
      }

      /* Deadzone: iOS momentum scrolling micro-reverses scrollY between
         frames; only commit on a clear move of more than 8px. */
      var delta = y - lastY;
      if (delta > 8) {
        header.classList.add('is-hidden');
        lastY = y;
      } else if (delta < -8) {
        header.classList.remove('is-hidden');
        lastY = y;
      }
    }

    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(onScroll);
    }, { passive: true });
    if (desktop.addEventListener) desktop.addEventListener('change', onScroll);
    onScroll();
    chipRest();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mq = window.matchMedia('(max-width: 768px)');
    var AUTO_SPEED = 0.5; /* px per frame — same smooth cadence as the galleries */

    function clearClones(track) {
      track.querySelectorAll('.logo-carousel__set:not([data-logo-set])').forEach(function (el) {
        el.remove();
      });
    }

    /* Desktop: CSS translate marquee (unchanged). Clone the set to fill the
       viewport + one extra, then drive it with the CSS keyframes. */
    function setupDesktop(track, original) {
      var st = track._logo;
      if (st) { if (st.stop) st.stop(); if (st.observer) st.observer.disconnect(); }
      track.classList.remove('is-mobile-scroll');
      clearClones(track);

      var setWidth = original.offsetWidth;
      if (!setWidth) return;

      var needed = Math.ceil(window.innerWidth / setWidth) + 1;
      for (var c = 0; c < needed; c++) {
        var clone = original.cloneNode(true);
        clone.removeAttribute('data-logo-set');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
      track.style.setProperty('--scroll-distance', '-' + setWidth + 'px');
    }

    /* Mobile: swipeable scroll container with a rAF auto-scroll that pauses on
       touch and resumes once the fling settles. Mirrors the gallery engine — we
       never write scrollLeft mid-gesture (that kills iOS momentum). */
    function setupMobile(track, original) {
      clearClones(track);
      track.classList.add('is-mobile-scroll');
      track.style.removeProperty('--scroll-distance');

      var originalWidth = original.offsetWidth;
      if (!originalWidth) return;

      var SETS = 3; /* original + 2 clones — buffer for two-way swiping */
      for (var s = 1; s < SETS; s++) {
        var clone = original.cloneNode(true);
        clone.removeAttribute('data-logo-set');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      /* Start one set in, so there's a buffer to swipe back into. */
      track.scrollLeft = originalWidth;

      var st = track._logo || (track._logo = {});
      st.autoScrollId = null;
      st.paused = false;
      st.touching = false;
      if (typeof st.inView !== 'boolean') st.inView = false;
      st.scrollPos = track.scrollLeft;
      if (st.resumeTimer) { clearTimeout(st.resumeTimer); st.resumeTimer = null; }

      function normalize() {
        var x = track.scrollLeft;
        while (x >= originalWidth * 2) x -= originalWidth;
        while (x < originalWidth) x += originalWidth;
        if (x !== track.scrollLeft) track.scrollLeft = x;
        st.scrollPos = track.scrollLeft;
      }
      function tick() {
        st.scrollPos += AUTO_SPEED;
        if (st.scrollPos >= originalWidth * 2) st.scrollPos -= originalWidth;
        /* Browsers round scrollLeft to whole pixels, so writing every frame at
           0.5px/frame is redundant work half the time — only write on change. */
        var next = Math.round(st.scrollPos);
        if (next !== st.lastLeft) { track.scrollLeft = next; st.lastLeft = next; }
        st.autoScrollId = requestAnimationFrame(tick);
      }
      st.start = function () {
        if (prefersReducedMotion || st.autoScrollId || st.paused || st.touching || !st.inView) return;
        st.scrollPos = track.scrollLeft;
        st.autoScrollId = requestAnimationFrame(tick);
      };
      st.stop = function () {
        if (st.autoScrollId) { cancelAnimationFrame(st.autoScrollId); st.autoScrollId = null; }
      };
      st.scheduleResume = function () {
        if (st.resumeTimer) clearTimeout(st.resumeTimer);
        st.resumeTimer = setTimeout(function () {
          st.resumeTimer = null;
          if (st.touching) return;
          st.paused = false;
          normalize();
          st.start();
        }, 600);
      };

      /* Bind touch + scroll listeners once; they read the latest fns off `st`. */
      if (!st.bound) {
        st.bound = true;
        track.addEventListener('touchstart', function () {
          st.touching = true;
          st.paused = true;
          if (st.stop) st.stop();
          if (st.resumeTimer) { clearTimeout(st.resumeTimer); st.resumeTimer = null; }
        }, { passive: true });
        var onTouchDone = function () { st.touching = false; if (st.scheduleResume) st.scheduleResume(); };
        track.addEventListener('touchend', onTouchDone, { passive: true });
        track.addEventListener('touchcancel', onTouchDone, { passive: true });
        track.addEventListener('scroll', function () {
          if (st.paused && !st.touching && st.scheduleResume) st.scheduleResume();
        }, { passive: true });
      }

      if (st.observer) st.observer.disconnect();
      var container = track.closest('.logo-carousel') || track;
      st.observer = new IntersectionObserver(function (entries) {
        st.inView = entries[0].isIntersecting;
        if (st.inView) st.start(); else st.stop();
      }, { threshold: 0.2 });
      st.observer.observe(container);
    }

    function build(track) {
      var original = track.querySelector('[data-logo-set]');
      if (!original) return;
      if (mq.matches) setupMobile(track, original);
      else setupDesktop(track, original);
    }

    function init() {
      document.querySelectorAll('[data-logo-track]').forEach(function (track) {
        build(track);
        /* re-measure after images decode (set width grows with logo widths) */
        var original = track.querySelector('[data-logo-set]');
        if (!original) return;
        var images = original.querySelectorAll('img');
        var pending = 0;
        images.forEach(function (img) {
          if (!img.complete) {
            pending++;
            var done = function () {
              img.removeEventListener('load', done);
              img.removeEventListener('error', done);
              /* Only re-measure on desktop (CSS-marquee width grows as images
                 decode). On mobile the item min-width keeps the width stable, and
                 rebuilding resets scrollLeft mid-scroll — that's the 1-2 "jumps"
                 at the start. */
              if (--pending === 0 && !mq.matches) build(track);
            };
            img.addEventListener('load', done);
            img.addEventListener('error', done);
          }
        });
      });
    }

    var resizeTimer;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      /* Mobile browsers fire `resize` when the address bar collapses/expands on
         vertical scroll — the height changes but the width doesn't. Rebuilding on
         those events tears down the carousel and resets scrollLeft, which is the
         flicker/jump seen while scrolling. Only rebuild on a real width change
         (orientation change or breakpoint cross). */
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(init, 150);
    });
    if (mq.addEventListener) mq.addEventListener('change', init);

    if (document.readyState !== 'loading') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initProcessSection(wrapper) {
      var section = wrapper.querySelector('.process');
      var bgs = section.querySelectorAll('.process__bg');
      var details = section.querySelectorAll('.process__detail');
      var steps = section.querySelectorAll('[data-process-step]');
      var bars = section.querySelectorAll('.process__step-bar');
      var stepCount = steps.length;

      if (stepCount === 0) return;

      var currentStep = 0;

      function setActiveStep(index) {
        for (var i = 0; i < bgs.length; i++) {
          bgs[i].style.opacity = i === index ? '1' : '0';
        }
        for (var i = 0; i < details.length; i++) {
          if (i === index) {
            details[i].classList.add('process__detail--active');
          } else {
            details[i].classList.remove('process__detail--active');
          }
        }
        for (var i = 0; i < steps.length; i++) {
          if (i === index) {
            steps[i].classList.add('process__step--active');
          } else {
            steps[i].classList.remove('process__step--active');
          }
        }
        for (var i = 0; i < bars.length; i++) {
          if (i < index) {
            bars[i].style.transform = 'scaleX(1)';
          } else if (i === index) {
            bars[i].style.transform = 'scaleX(1)';
          } else {
            bars[i].style.transform = 'scaleX(0)';
          }
        }
      }

      if (prefersReducedMotion) {
        for (var i = 0; i < steps.length; i++) {
          steps[i].style.cursor = 'pointer';
          steps[i].addEventListener('click', (function(step) {
            return function() {
              var index = parseInt(step.getAttribute('data-process-step'), 10);
              setActiveStep(index);
            };
          })(steps[i]));
        }
        if (bars[0]) {
          bars[0].style.transform = 'scaleX(1)';
        }
        return;
      }

      /* Smoothed scroll: the scroll handler only updates a TARGET progress; a
         rAF loop eases the DISPLAYED progress toward it, so the bars glide
         instead of tracking 1:1 — same feel as GSAP's numeric scrub on the
         showcase section. The loop runs only while catching up, then stops. */
      var targetProgress = 0, displayProgress = 0, rafId = null, running = false, primed = false;
      var EASE = 0.12; /* per-frame approach; lower = smoother/laggier */

      function computeTarget() {
        var rect = wrapper.getBoundingClientRect();
        var scrollable = wrapper.offsetHeight - window.innerHeight;
        if (scrollable <= 0) return null;
        return Math.max(0, Math.min(1, -rect.top / scrollable));
      }

      function render(progress) {
        var newStep = Math.min(Math.floor(progress * stepCount), stepCount - 1);
        var stepProgress = (progress * stepCount) - newStep;
        for (var i = 0; i < bars.length; i++) {
          if (i < newStep) {
            bars[i].style.transform = 'scaleX(1)';
          } else if (i === newStep) {
            bars[i].style.transform = 'scaleX(' + stepProgress + ')';
          } else {
            bars[i].style.transform = 'scaleX(0)';
          }
        }

        if (newStep !== currentStep) {
          for (var j = 0; j < bgs.length; j++) {
            bgs[j].style.opacity = j === newStep ? '1' : '0';
          }
          for (var k = 0; k < details.length; k++) {
            if (k === newStep) {
              details[k].classList.add('process__detail--active');
            } else {
              details[k].classList.remove('process__detail--active');
            }
          }
          for (var s = 0; s < steps.length; s++) {
            if (s === newStep) {
              steps[s].classList.add('process__step--active');
            } else {
              steps[s].classList.remove('process__step--active');
            }
          }
          currentStep = newStep;
        }
      }

      function tick() {
        var diff = targetProgress - displayProgress;
        if (Math.abs(diff) < 0.0004) {
          displayProgress = targetProgress;
          render(displayProgress);
          running = false;
          return;
        }
        displayProgress += diff * EASE;
        render(displayProgress);
        rafId = requestAnimationFrame(tick);
      }

      function onScroll() {
        var p = computeTarget();
        if (p === null) return;
        targetProgress = p;
        if (!primed) {
          /* First read (or a mid-section reload): snap, don't animate up from 0. */
          primed = true;
          displayProgress = p;
          render(displayProgress);
          return;
        }
        if (!running) { running = true; rafId = requestAnimationFrame(tick); }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      section._processCleanup = function() {
        window.removeEventListener('scroll', onScroll);
        if (rafId) cancelAnimationFrame(rafId);
      };
    }

    function init() {
      document.querySelectorAll('.process-wrapper').forEach(initProcessSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:unload', function(event) {
      var section = event.target.querySelector('.process');
      if (section && section._processCleanup) {
        section._processCleanup();
      }
    });

    document.addEventListener('shopify:section:load', function(event) {
      var wrapper = event.target.querySelector('.process-wrapper');
      if (wrapper) {
        initProcessSection(wrapper);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-categories"] && !Shopify.designMode) return;
  try {
    
  const section = document.querySelector('.product-categories');
  if (section) {
    const filters = section.querySelectorAll('[data-filter]');
    const cards = section.querySelectorAll('[data-category]');

    filters.forEach(function(filter) {
      filter.addEventListener('click', function() {
        const tag = this.getAttribute('data-filter');

        filters.forEach(function(f) {
          f.classList.remove('filter-tab--active');
          f.setAttribute('aria-selected', 'false');
        });
        this.classList.add('filter-tab--active');
        this.setAttribute('aria-selected', 'true');

        cards.forEach(function(card) {
          var categories = card.getAttribute('data-category') || '';
          if (tag === 'all' || categories.split(' ').indexOf(tag) !== -1) {
            card.removeAttribute('hidden');
          } else {
            card.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery"]) return;
  try {
    
  /* Continuous auto-scroll marquee — identical mechanism to the industry
     gallery (gallery-section): clone the items for a seamless loop, advance
     scrollLeft each frame, and only run while the gallery is in view. */
  (function() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    /* 1 original + 4 clones. Start in the CENTER set for 2 sets of buffer each
       way. Clones are identical, so re-centering (normalize) is invisible. */
    var SETS = 5, CENTER = 2;

    document.querySelectorAll('.product-gallery__grid-wrapper').forEach(function(wrapper) {
      var track = wrapper.querySelector('.product-gallery__grid');
      if (!track) return;

      var items = track.querySelectorAll('.product-gallery__item');
      if (items.length === 0) return;

      var gap = 8;
      var originalWidth = 0;
      items.forEach(function(item) { originalWidth += item.offsetWidth + gap; });

      for (var s = 1; s < SETS; s++) {
        items.forEach(function(item) {
          var clone = item.cloneNode(true);
          clone.removeAttribute('data-shopify-editor-block');
          track.appendChild(clone);
        });
      }

      /* Start in the center set — buffer both directions. */
      track.scrollLeft = CENTER * originalWidth;

      var autoScrollId = null;
      /* Float accumulator — iOS rounds scrollLeft to an integer, so `+= 0.5`
         read back from the DOM never advances. We keep our own position. */
      var scrollPos = track.scrollLeft;
      var paused = false;      /* auto-scroll suspended (user interacting or settling) */
      var interacting = false; /* a finger or mouse button is currently down */
      var dragging = false;    /* mouse click-drag in progress */
      var touching = false;    /* touch gesture in progress (mobile) */
      var inView = false;
      var resumeTimer = null;

      /* Re-center into the center set. Clones are identical, so shifting by whole
         set-widths is invisible. Not called mid-touch-fling (writing scrollLeft
         then kills iOS momentum). */
      function normalize() {
        var x = track.scrollLeft;
        while (x >= (CENTER + 1) * originalWidth) x -= originalWidth;
        while (x < CENTER * originalWidth) x += originalWidth;
        if (x !== track.scrollLeft) track.scrollLeft = x;
        scrollPos = track.scrollLeft;
      }

      function tick() {
        scrollPos += 0.75; /* px per frame (~45px/s at 60fps) */
        if (scrollPos >= (CENTER + 1) * originalWidth) scrollPos -= originalWidth;
        track.scrollLeft = scrollPos;
        autoScrollId = requestAnimationFrame(tick);
      }

      function startAutoScroll() {
        if (prefersReducedMotion || autoScrollId || paused || interacting || !inView) return;
        scrollPos = track.scrollLeft; /* sync to wherever we are now */
        autoScrollId = requestAnimationFrame(tick);
      }

      function stopAutoScroll() {
        if (autoScrollId) { cancelAnimationFrame(autoScrollId); autoScrollId = null; }
      }

      function scheduleResume() {
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function() {
          resumeTimer = null;
          if (interacting) return;
          paused = false;
          normalize();
          startAutoScroll();
        }, 800);
      }

      /* Users can scrub the gallery themselves — touch swipe, trackpad/shift-wheel,
         or click-drag. The auto-scroll pauses the moment they interact and resumes
         once idle. We key off the INPUT events (not scroll position), so the loop's
         own scrollLeft writes are never mistaken for user input (the old jam). */
      function pauseNow() {
        paused = true;
        stopAutoScroll();
        if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
      }

      /* Touch (mobile): pause on contact, resume after the fling settles. */
      track.addEventListener('touchstart', function() { touching = true; interacting = true; pauseNow(); }, { passive: true });
      var onTouchDone = function() { touching = false; interacting = false; scheduleResume(); };
      track.addEventListener('touchend', onTouchDone, { passive: true });
      track.addEventListener('touchcancel', onTouchDone, { passive: true });

      /* Horizontal wheel / shift-wheel / trackpad. Ignore vertical-intent wheels
         so scrolling the PAGE past the gallery doesn't pause it. */
      track.addEventListener('wheel', function(e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        pauseNow();
        scheduleResume();
      }, { passive: true });

      /* Mouse click-drag to scrub (desktop). Touch is handled above. */
      var startX = 0, startScroll = 0;
      track.addEventListener('pointerdown', function(e) {
        if (e.pointerType === 'touch') return;
        dragging = true;
        interacting = true;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        pauseNow();
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', function(e) {
        if (!dragging) return;
        track.scrollLeft = startScroll - (e.clientX - startX);
      });
      var endDrag = function() {
        if (!dragging) return;
        dragging = false;
        interacting = false;
        track.classList.remove('is-dragging');
        normalize(); /* invisible re-center so the next drag has full buffer */
        scheduleResume();
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      /* Inertia keeps firing scroll events after a gesture; each pushes the resume
         back so we only restart once movement fully stops. Guarded by `paused` so
         the auto-scroll's own writes are ignored. */
      track.addEventListener('scroll', function() {
        if (paused && !interacting) scheduleResume();
      }, { passive: true });

      var observer = new IntersectionObserver(function(entries) {
        inView = entries[0].isIntersecting;
        if (inView) startAutoScroll();
        else stopAutoScroll();
      }, { threshold: 0.2 });

      observer.observe(wrapper);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.product-main');
    if (!section) return;

    var cfg = section.dataset;
    var jsonEl = section.closest('.shopify-section').querySelector('[data-product-json]');
    var variants = JSON.parse(jsonEl.textContent);
    var form = section.querySelector('[data-product-form]');
    var variantInput = form.querySelector('[data-variant-id]');
    var perUnitEl = section.querySelector('[data-price-per-unit]');
    var totalEl = section.querySelector('[data-estimated-total]');
    var qtyInput = section.querySelector('[data-qty-input]');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var addLabel = section.querySelector('[data-add-label]');

    /* 1-based position of the quantity-tier option (0 = none) */
    var tierPosition = parseInt(cfg.tierPosition, 10) || 0;
    var currency = cfg.currency || 'USD';
    var locale = document.documentElement.getAttribute('lang') || undefined;

    var fmt;
    try {
      fmt = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
    } catch (e) {
      fmt = { format: function (n) { return '$' + n.toFixed(2); } };
    }
    function money(cents) { return fmt.format(cents / 100); }

    /* Build sorted tier list [{ value, min }] from the variant option at tierPosition */
    var tiers = [];
    if (tierPosition) {
      var seen = {};
      variants.forEach(function (v) {
        var val = v.options[tierPosition - 1];
        if (val != null && !seen[val]) {
          seen[val] = true;
          var min = parseInt(String(val).replace(/[^0-9]/g, ''), 10);
          tiers.push({ value: val, min: isNaN(min) ? 1 : min });
        }
      });
      tiers.sort(function (a, b) { return a.min - b.min; });
    }

    function getQty() {
      var q = parseInt(qtyInput.value, 10);
      return isNaN(q) || q < 1 ? 1 : q;
    }

    function resolveTier(qty) {
      var chosen = tiers.length ? tiers[0].value : null;
      tiers.forEach(function (t) { if (qty >= t.min) chosen = t.value; });
      return chosen;
    }

    /* Selected non-tier options from the rendered pills */
    var selected = {};
    section.querySelectorAll('[data-option-position]').forEach(function (group) {
      var pos = group.getAttribute('data-option-position');
      var active = group.querySelector('.product-main__pill--selected');
      if (active) selected[pos] = active.getAttribute('data-option-value');
    });

    function findVariant() {
      var tierVal = tierPosition ? resolveTier(getQty()) : null;
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          var pos = i + 1;
          if (pos === tierPosition) return tierVal === null || opt === tierVal;
          return !selected[pos] || selected[String(pos)] === opt;
        });
      });
    }

    function update() {
      var v = findVariant();
      if (!v) return;
      variantInput.value = v.id;
      var qty = getQty();
      if (perUnitEl) perUnitEl.textContent = money(v.price);
      if (totalEl) totalEl.textContent = money(v.price * qty);
      submitBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? cfg.labelAdd : cfg.labelSoldout;
      var url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }

    section.querySelectorAll('[data-option-position]').forEach(function (group) {
      var pos = group.getAttribute('data-option-position');
      group.addEventListener('click', function (e) {
        var pill = e.target.closest('.product-main__pill');
        if (!pill) return;
        group.querySelectorAll('.product-main__pill').forEach(function (p) {
          p.classList.remove('product-main__pill--selected');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('product-main__pill--selected');
        pill.setAttribute('aria-pressed', 'true');
        selected[pos] = pill.getAttribute('data-option-value');
        update();
      });
    });

    section.querySelector('[data-qty-decrease]').addEventListener('click', function () {
      var val = getQty();
      if (val > 1) { qtyInput.value = val - 1; update(); }
    });
    section.querySelector('[data-qty-increase]').addEventListener('click', function () {
      qtyInput.value = getQty() + 1; update();
    });
    qtyInput.addEventListener('input', function () {
      var val = parseInt(this.value, 10);
      if (isNaN(val) || val < 1) this.value = '';
      update();
    });

    /* Normalize price/total on load (Intl format may differ from server money filter) */
    update();

    /* AJAX add-to-cart → open the cart drawer if present, else submit normally */
    form.addEventListener('submit', function (e) {
      if (typeof window.fkCartDrawer === 'undefined') return; /* no drawer → native POST */
      e.preventDefault();
      submitBtn.disabled = true;
      var data = new FormData(form);
      fetch(cfg.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
      })
        .then(function (r) { return r.json(); })
        .then(function () { return window.fkCartDrawer.refresh(); })
        .then(function () { window.fkCartDrawer.open(); submitBtn.disabled = false; })
        .catch(function () { form.submit(); });
    });

    /* Gallery */
    var slides = section.querySelectorAll('.product-main__slide');
    var thumbs = section.querySelectorAll('.product-main__thumb');
    var current = 0;
    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      slides.forEach(function (s) { s.classList.remove('product-main__slide--active'); });
      thumbs.forEach(function (t) { t.classList.remove('product-main__thumb--active'); });
      slides[i].classList.add('product-main__slide--active');
      if (thumbs[i]) {
        thumbs[i].classList.add('product-main__thumb--active');
        /* Keep the active thumbnail in view within the horizontal scroller. */
        thumbs[i].scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      }
      current = i;
    }
    var prev = section.querySelector('[data-gallery-prev]');
    var next = section.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(this.getAttribute('data-thumb-index'), 10)); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-shopping"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.product-shopping');
    if (!section) return;

    var variants = JSON.parse(
      section.closest('.shopify-section').querySelector('[data-product-json]').textContent
    );
    var form = section.querySelector('[data-product-form]');
    var variantInput = form.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-product-price]');
    var overviewName = section.querySelector('[data-overview-name]');
    var overviewPrice = section.querySelector('[data-overview-price]');
    var overviewTotal = section.querySelector('[data-overview-total]');
    var qtyInput = section.querySelector('[data-qty-input]');
    var submitBtn = form.querySelector('[type="submit"]');

    /* ── Selected options state ── */
    var selectedOptions = {};
    section.querySelectorAll('[data-option-position]').forEach(function(group) {
      var pos = group.getAttribute('data-option-position');
      var active = group.querySelector('.product-shopping__pill--selected');
      if (active) {
        selectedOptions[pos] = active.getAttribute('data-option-value');
      }
    });

    /* Quantity-tier pricing: parse the hidden "N+ units" tier option into
       { value, min } thresholds so the entered quantity selects the matching
       tier's variant (and therefore its per-unit price from Shopify). */
    var tierGroup = section.querySelector('[data-tier-option]');
    var tierPos = tierGroup ? tierGroup.getAttribute('data-option-position') : null;
    var tiers = [];
    if (tierGroup) {
      tierGroup.querySelectorAll('[data-option-value]').forEach(function(pill) {
        var raw = pill.getAttribute('data-option-value');
        var min = parseInt(raw.replace(/[^0-9]/g, ''), 10);
        if (!isNaN(min)) tiers.push({ value: raw, min: min });
      });
      tiers.sort(function(a, b) { return a.min - b.min; });
    }

    /* Format prices in the visitor's presentment currency (Shopify Markets) so a
       NL shopper sees the euro symbol and a US shopper sees the dollar symbol —
       instead of a hardcoded dollar sign. The currency code is read from the
       section's data-currency attribute (Liquid is not rendered in this script
       block). Falls back to USD if the code is missing or invalid. */
    var moneyCurrency = section.getAttribute('data-currency') || 'USD';
    var moneyFormatter;
    try {
      moneyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: moneyCurrency });
    } catch (e) {
      moneyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    }
    function formatMoney(cents) {
      return moneyFormatter.format(cents / 100);
    }

    function findVariant() {
      return variants.find(function(v) {
        return v.options.every(function(opt, i) {
          var pos = String(i + 1);
          return !selectedOptions[pos] || selectedOptions[pos] === opt;
        });
      });
    }

    function updateVariant() {
      var qty = parseInt(qtyInput.value, 10) || 1;

      /* The entered quantity selects the matching bulk tier: the highest tier
         whose threshold the quantity reaches. Its Shopify variant price then
         becomes the per-unit price. */
      if (tierPos && tiers.length) {
        var chosen = tiers[0];
        for (var t = 0; t < tiers.length; t++) {
          if (qty >= tiers[t].min) chosen = tiers[t];
        }
        selectedOptions[tierPos] = chosen.value;
      }

      var variant = findVariant();
      if (!variant) return;

      variantInput.value = variant.id;

      var price = formatMoney(variant.price);
      priceEl.textContent = price;
      overviewPrice.textContent = price;

      overviewTotal.textContent = formatMoney(variant.price * qty);

      /* Update overview name with selected size */
      var sizeOpt = selectedOptions['2'];
      if (sizeOpt && overviewName) {
        var baseTitle = overviewName.textContent.replace(/\s*\(.*?\)\s*$/, '');
        overviewName.textContent = baseTitle;
      }

      submitBtn.disabled = !variant.available;

      /* Update URL without reload */
      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    /* ── Option pills ── */
    section.querySelectorAll('[data-option-position]').forEach(function(group) {
      var pos = group.getAttribute('data-option-position');
      group.addEventListener('click', function(e) {
        var pill = e.target.closest('.product-shopping__pill');
        if (!pill) return;

        group.querySelectorAll('.product-shopping__pill').forEach(function(p) {
          p.classList.remove('product-shopping__pill--selected');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('product-shopping__pill--selected');
        pill.setAttribute('aria-pressed', 'true');

        selectedOptions[pos] = pill.getAttribute('data-option-value');
        updateVariant();
      });
    });

    /* ── Quantity ── */
    section.querySelector('[data-qty-decrease]').addEventListener('click', function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) {
        qtyInput.value = val - 1;
        updateVariant();
      }
    });

    section.querySelector('[data-qty-increase]').addEventListener('click', function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
      updateVariant();
    });

    qtyInput.addEventListener('change', function() {
      var val = parseInt(this.value, 10);
      if (isNaN(val) || val < 1) this.value = 1;
      updateVariant();
    });

    /* Sync price + tier to the initial quantity on load (the server render may
       default to a different tier than the qty-1 tier). */
    updateVariant();

    /* ── Image gallery ── */
    var slides = section.querySelectorAll('.product-shopping__main-slide');
    var thumbs = section.querySelectorAll('.product-shopping__thumb');
    var currentSlide = 0;

    function goToSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides.forEach(function(s) { s.classList.remove('product-shopping__main-slide--active'); });
      thumbs.forEach(function(t) { t.classList.remove('product-shopping__thumb--active'); });

      slides[index].classList.add('product-shopping__main-slide--active');
      if (thumbs[index]) {
        thumbs[index].classList.add('product-shopping__thumb--active');
        /* Keep the active thumbnail in view within the horizontal scroller. */
        thumbs[index].scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      }
      currentSlide = index;
    }

    var prevBtn = section.querySelector('[data-gallery-prev]');
    var nextBtn = section.querySelector('[data-gallery-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        goToSlide(currentSlide - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        goToSlide(currentSlide + 1);
      });
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-thumb-index'), 10);
        goToSlide(idx);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-showcase"] && !Shopify.designMode) return;
  try {
    
  /* Reveal the pinned hero's content on scroll (Cowboy-style). CSS handles the
     pinning via position:sticky over a tall track; this just scrubs the content
     in as you scroll through it. gsap.matchMedia scopes it to desktop + motion
     and cleans up on resize. */
  (function() {
    if (!window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);

    /* Don't treat the mobile URL-bar show/hide (which fires a viewport resize) as
       a real resize — otherwise ScrollTrigger refreshes mid-scroll and the pin
       jumps, which also nudges the auto-hiding navbar. */
    ScrollTrigger.config({ ignoreMobileResize: true });

    document.querySelectorAll('[data-showcase-pin]').forEach(function(section) {
      var content = section.querySelector('.project-showcase__content');
      if (!content) return;

      gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', function() {
        /* Slide the whole content block up from below the fold, tracking scroll
           1:1 — no fade. The heading (top of the block) enters first, then the
           rest climbs into view as you keep scrolling.
           End position: rest the block low, bottom edge ~10vh off the viewport
           floor (content is flex-centred at 50vh, so this puts its bottom at
           ~90vh) — the pin then releases straight into materials with barely any
           empty hero to scroll through. On tall displays (Studio Display etc.)
           the block is short relative to the viewport, so that same rule would
           park it too low; cap how far down it settles (~42vh from the top) so
           it still climbs up nicely. */
        var tween = gsap.fromTo(
          content,
          { y: function() { return window.innerHeight; } },
          {
            y: function() {
              var vh = window.innerHeight;
              var ch = content.offsetHeight;
              var restedTop = Math.min(vh * 0.9 - ch, vh * 0.42);
              return restedTop - (vh / 2 - ch / 2);
            },
            ease: 'none',
            scrollTrigger: {
              trigger: section,
              start: 'top top',
              end: 'bottom bottom',
              /* Numeric scrub eases the reveal ~0.6s toward the scroll position
                 (instead of tracking 1:1), giving the pinned section a smoother,
                 gliding feel without hijacking page scroll. */
              scrub: 0.6,
              invalidateOnRefresh: true,
            },
          }
        );

        return function() {
          if (tween.scrollTrigger) { tween.scrollTrigger.kill(); }
          gsap.set(content, { clearProps: 'transform' });
        };
      });
    });

    /* This block is deferred and the sections above use lazy images, so the
       trigger's cached start/end can be stale (progress stuck at 0). Refresh
       (debounced) whenever the layout above can shift — on load, on fonts, and
       as images finish loading.
       CRITICAL: never run the refresh while the user is actively scrolling.
       ScrollTrigger.refresh() mid-momentum on iOS halts the scroll dead (and
       nudges the position, which makes the auto-hiding navbar pop in). Lazy
       images down the page fire `load` as you scroll past them, so an ungated
       refresh stutters every scroll. Defer until the scroll has been idle. */
    var rt, lastScrollAt = 0;
    window.addEventListener('scroll', function() { lastScrollAt = Date.now(); }, { passive: true });
    function refresh() {
      clearTimeout(rt);
      rt = setTimeout(function run() {
        if (Date.now() - lastScrollAt < 400) { rt = setTimeout(run, 250); return; }
        ScrollTrigger.refresh();
      }, 200);
    }
    window.addEventListener('load', refresh);
    if (document.readyState === 'complete') { refresh(); }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(refresh); }
    document.querySelectorAll('img').forEach(function(img) {
      if (!img.complete) { img.addEventListener('load', refresh, { once: true }); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-modal-original"]) return;
  try {
    
  var widget = document.getElementById('quote-widget');
  if (!widget) return;

  var pill = widget.querySelector('.quote-widget__pill');
  var openLabel = widget.querySelector('.quote-widget__pill-open');
  var submitLabel = widget.querySelector('.quote-widget__pill-submit');
  var arrowCircle = widget.querySelector('.quote-widget__pill-arrow circle');
  var arrowPath = widget.querySelector('.quote-widget__pill-arrow path');
  var bodyEl = widget.querySelector('.quote-widget__body');
  var actionsEl = widget.querySelector('.quote-widget__actions');
  var infoEl = widget.querySelector('.quote-widget__info');
  var closeBtn = widget.querySelector('.quote-widget-og__close');
  var backdrop = document.getElementById('quote-backdrop');
  var form = widget.querySelector('form');
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var isOpen = false;
  var isAnimating = false;
  var pillMetrics = null;
  var entranceTween = null;
  var openTl = null;

  function g() { return typeof gsap !== 'undefined'; }

  /* ── Triggers ── */

  pill.addEventListener('click', function() {
    if (isOpen) {
      if (form) {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }
    } else {
      openWidget();
    }
  });

  closeBtn.addEventListener('click', function() { closeWidget(); });

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-open="quote-modal"]')) {
      e.preventDefault();
      openWidget();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen && !isAnimating) {
      e.preventDefault();
      closeWidget();
    }
  });

  if (backdrop) {
    backdrop.addEventListener('click', function() {
      if (isOpen && !isAnimating) closeWidget();
    });
  }

  /* ── File upload ── */

  var fileInput = widget.querySelector('[data-file-input]');
  var fileTrigger = widget.querySelector('[data-file-trigger]');
  var fileName = widget.querySelector('[data-file-name]');

  if (fileTrigger && fileInput && fileName) {
    fileTrigger.addEventListener('click', function() { fileInput.click(); });
    fileInput.addEventListener('change', function() {
      fileName.textContent = fileInput.files.length > 0
        ? fileInput.files[0].name
        : 'No file chosen';
    });
  }

  /* ── Open ── */

  function openWidget() {
    if (isAnimating || isOpen) return;
    isOpen = true;
    isAnimating = true;

    if (entranceTween) { entranceTween.kill(); entranceTween = null; }

    pill.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';

    var cs = getComputedStyle;
    var circleSize = pill.offsetHeight;

    pillMetrics = {
      w: widget.offsetWidth,
      h: widget.offsetHeight,
      bg: cs(widget).backgroundColor,
      rad: cs(widget).borderRadius,
      pw: pill.offsetWidth,
      pbg: cs(pill).backgroundColor,
    };

    /* Apply expanded class and measure */
    widget.classList.add('is-open');

    var lw = widget.offsetWidth;
    var lh = widget.offsetHeight;
    var lbg = cs(widget).backgroundColor;
    var lrad = cs(widget).borderRadius;
    var lpw = pill.offsetWidth;
    var lpbg = cs(pill).backgroundColor;
    var lActPad = cs(actionsEl).padding;

    if (!g() || prefersReducedMotion) {
      backdrop.style.opacity = '1';
      backdrop.style.pointerEvents = 'auto';
      isAnimating = false;
      setInert(true);
      focusFirst();
      return;
    }

    /* FLIP invert */
    gsap.set(widget, {
      width: pillMetrics.w, height: pillMetrics.h,
      backgroundColor: pillMetrics.bg, borderRadius: pillMetrics.rad,
      overflow: 'hidden',
    });
    gsap.set(pill, { backgroundColor: pillMetrics.pbg, width: pillMetrics.pw });
    gsap.set(actionsEl, { padding: 0 });
    gsap.set(bodyEl, { autoAlpha: 0, y: 30 });
    gsap.set(closeBtn, { autoAlpha: 0, scale: 0.5 });
    gsap.set(infoEl, { display: 'none' });
    gsap.set(openLabel, { display: 'block', autoAlpha: 1 });
    gsap.set(submitLabel, { display: 'none', autoAlpha: 0 });

    /* Three-phase timeline — stored so close can .reverse() it */
    openTl = gsap.timeline({
      paused: true,
      onComplete: function() {
        isAnimating = false;
        setInert(true);
        focusFirst();
      },
      onReverseComplete: function() {
        isOpen = false;
        isAnimating = false;
        widget.classList.remove('is-open');
        gsap.set(widget, { clearProps: 'all' });
        gsap.set(pill, { clearProps: 'all' });
        gsap.set(actionsEl, { clearProps: 'all' });
        gsap.set(bodyEl, { clearProps: 'all' });
        gsap.set(closeBtn, { clearProps: 'all' });
        gsap.set(infoEl, { clearProps: 'all' });
        gsap.set([openLabel, submitLabel], { clearProps: 'all' });
        gsap.set(backdrop, { clearProps: 'all' });
        if (arrowCircle) gsap.set(arrowCircle, { clearProps: 'all' });
        if (arrowPath) gsap.set(arrowPath, { clearProps: 'all' });
        pill.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        openTl = null;
        pill.focus();
      },
    });

    var tl = openTl;

    /* ── Phase 1: Widget clips down to arrow circle (0–0.25s) ── */
    /* Only the widget width shrinks — pill stays full size but gets clipped.
       Arrow stays at the right edge (justify-content: flex-end + overflow: hidden). */
    tl.to(openLabel, { autoAlpha: 0, duration: 0.15, ease: 'power2.in' }, 0);
    tl.set(openLabel, { display: 'none' }, 0.15);

    tl.to(widget, {
      width: circleSize,
      duration: 0.25, ease: 'power2.inOut',
    }, 0);

    /* ── Phase 2: Expand + color + text (0.27–0.7s) ── */
    tl.to(widget, {
      width: lw, height: lh,
      backgroundColor: lbg, borderRadius: lrad,
      duration: 0.45, ease: 'power3.inOut',
    }, 0.27);

    tl.to(pill, {
      backgroundColor: lpbg, width: lpw, paddingLeft: 20, gap: 16,
      duration: 0.4, ease: 'power3.out',
    }, 0.27);

    tl.to(actionsEl, {
      padding: lActPad,
      duration: 0.35, ease: 'power3.inOut',
    }, 0.3);

    if (arrowCircle) {
      tl.to(arrowCircle, { attr: { fill: '#ffffff' }, duration: 0.3 }, 0.4);
    }
    if (arrowPath) {
      tl.to(arrowPath, { attr: { stroke: '#1b1b1b' }, duration: 0.3 }, 0.4);
    }

    tl.set(submitLabel, { display: 'block' }, 0.42);
    tl.fromTo(submitLabel, { autoAlpha: 0 }, {
      autoAlpha: 1, duration: 0.2, ease: 'power2.out',
    }, 0.42);

    /* ── Phase 3: Content appears (0.55–0.85s) ── */
    tl.fromTo(bodyEl, { autoAlpha: 0, y: 20 }, {
      autoAlpha: 1, y: 0, duration: 0.3, ease: 'power2.out',
    }, 0.55);

    tl.fromTo(closeBtn, { autoAlpha: 0, scale: 0.5 }, {
      autoAlpha: 1, scale: 1, duration: 0.25, ease: 'back.out(1.5)',
    }, 0.58);

    tl.set(infoEl, { display: 'flex' }, 0.62);
    tl.fromTo(infoEl, { autoAlpha: 0 }, {
      autoAlpha: 1, duration: 0.2, ease: 'power2.out',
    }, 0.62);

    /* Backdrop */
    tl.fromTo(backdrop, { opacity: 0, pointerEvents: 'none' }, {
      opacity: 1, pointerEvents: 'auto', duration: 0.5, ease: 'power2.out',
    }, 0);

    tl.play();
  }

  /* ── Close ── */

  function closeWidget() {
    if (isAnimating || !isOpen) return;
    isAnimating = true;
    setInert(false);

    if (!g() || prefersReducedMotion || !openTl) {
      widget.classList.remove('is-open');
      backdrop.style.opacity = '0';
      backdrop.style.pointerEvents = 'none';
      isOpen = false;
      isAnimating = false;
      pill.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      pill.focus();
      return;
    }

    openTl.reverse();
  }

  /* ── Helpers ── */

  function setInert(value) {
    var els = document.body.children;
    for (var i = 0; i < els.length; i++) {
      if (els[i].contains(widget) || els[i].tagName === 'SCRIPT') continue;
      els[i].inert = value;
    }
  }

  function focusFirst() {
    var input = widget.querySelector('input, textarea');
    if (input) input.focus();
  }

  /* ── Entrance ── */

  if (g() && !prefersReducedMotion) {
    gsap.set(widget, { autoAlpha: 0, y: 20 });
    entranceTween = gsap.to(widget, {
      autoAlpha: 1, y: 0, duration: 0.6, delay: 1, ease: 'power2.out',
      onComplete: function() { entranceTween = null; },
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-modal"]) return;
  try {
    
  var widget = document.getElementById('quote-widget');
  if (!widget) return;

  var backdrop = document.getElementById('quote-backdrop');
  var content = document.getElementById('quote-content');
  var messagesEl = document.getElementById('quote-messages');
  var chipsEl = document.getElementById('quote-chips');
  var inputRow = widget.querySelector('.quote-widget__input-row');
  var pillLabel = widget.querySelector('.quote-widget__pill-label');
  var dotIcon = widget.querySelector('.quote-widget__dot-icon');
  var inputField = document.getElementById('quote-input');
  var sendBtn = document.getElementById('quote-send');
  var closeBtn = widget.querySelector('.quote-widget__close');
  var topbar = widget.querySelector('.quote-widget__topbar');
  var formView = document.getElementById('quote-form-view');
  var backBtn = document.getElementById('quote-back-btn');
  var skipFormBtn = document.getElementById('quote-skip-form');

  var isOpen = false;
  var isAnimating = false;
  var openTl = null;
  var entranceTween = null;
  var pillW, pillH;
  var triggerEl = null;

  /* ── Focus trap ── */
  function trapFocus(e) {
    if (!isOpen || e.key !== 'Tab') return;
    var focusable = widget.querySelectorAll('button:not([hidden]):not([disabled]), input:not([hidden]):not([disabled]), textarea:not([hidden]):not([disabled]), a[href]:not([hidden])');
    var visible = Array.prototype.filter.call(focusable, function(el) { return el.offsetParent !== null; });
    if (!visible.length) return;
    var first = visible[0];
    var last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  document.addEventListener('keydown', trapFocus);

  function g() { return typeof gsap !== 'undefined'; }
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Visual-viewport handling (iOS) ──
     Two jobs, depending on state:
     • OPEN modal → size it above the keyboard. Only react to RESIZE (keyboard
       open/close), never scroll — chasing scroll ticks makes the modal jump
       around hectically as it fights iOS's own scrolling.
     • COLLAPSED pill → sit just above the *visible* bottom so it tracks the
       browser's dynamic bottom toolbar (e.g. iOS Chrome). When the bar hides
       the pill drops down with it instead of floating high. This one DOES need
       scroll, since the bar shows/hides on scroll — but it's just a small pill,
       not the keyboard, so it's calm. */
  if (window.visualViewport) {
    var vv = window.visualViewport;
    var vvRaf = null;

    function applyViewport() {
      vvRaf = null;
      /* Bottom area currently obscured by browser/keyboard UI. Subtract
         offsetTop so a panned viewport doesn't overestimate it. */
      var offset = window.innerHeight - vv.height - vv.offsetTop;

      if (isOpen) {
        if (offset > 50) {
          widget.style.bottom = (offset + 8) + 'px';
          widget.style.maxHeight = (vv.height - 16) + 'px';
        } else {
          widget.style.bottom = '';
          widget.style.maxHeight = '';
        }
      } else {
        widget.style.maxHeight = '';
        if (offset > 1) {
          /* Lift above the bottom toolbar; offset already includes the home
             indicator area it covers, so no extra safe-area inset here. */
          widget.style.bottom = 'calc(' + offset + 'px + var(--space-4))';
        } else {
          /* No bottom bar — fall back to the CSS base (16px + safe area). */
          widget.style.bottom = '';
        }
      }
    }

    function scheduleViewport() {
      if (vvRaf) return;
      vvRaf = requestAnimationFrame(applyViewport);
    }

    /* Resize → keyboard open/close + toolbar. Scroll → only the collapsed pill
       (guarded), so the open modal never re-enters scroll-chasing. */
    vv.addEventListener('resize', scheduleViewport);
    vv.addEventListener('scroll', function() { if (!isOpen) scheduleViewport(); });
    scheduleViewport();
  }

  /* ── Keep the focused form field visible above the keyboard ──
     The modal is already sized above the keyboard (resize handler above), but a
     field lower in the form still needs scrolling up into that area. After the
     keyboard settles, centre it in its scroll container. This is the second
     half of the standard iOS pattern (size above keyboard → scroll field into
     view). Crucially, no scroll listener runs while the modal is open, so this
     single scroll isn't fought by anything — that was what made it jumpy before.
     Only the FORM fields need this; the chat input sits at the bottom by design. */
  if (formView) {
    formView.addEventListener('focusin', function(e) {
      var el = e.target;
      if (!el || (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA')) return;
      if (!el.scrollIntoView) return;
      setTimeout(function() {
        if (document.activeElement !== el) return;
        /* Only scroll if the field is actually obscured. If iOS already placed
           it comfortably in the visible area, scrolling again causes a needless
           second jump — that's the occasional "it jumps a bit" you saw. */
        var rect = el.getBoundingClientRect();
        var top = vv ? vv.offsetTop : 0;
        var bottom = top + (vv ? vv.height : window.innerHeight);
        if (rect.top >= top + 8 && rect.bottom <= bottom - 8) return;
        el.scrollIntoView({ block: 'center' });
      }, 300);
    });
  }

  /* ── HTML escape (XSS prevention) ── */
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* ── FAQ ── */
  /* ── Page routes — keyword → page URL ── */
  var pageRoutes = [
    { k: ['custom inflatable','inflatable','inflatables','blow up','blowup'], label: 'Custom inflatables', url: '/pages/custom-inflatables' },
    { k: ['pool float','pool floats','float'], label: 'Custom pool floats', url: '/pages/custom-pool-floats' },
    { k: ['promo','promotional','agency','agencies','marketing'], label: 'Promotional & agencies', url: '/pages/promotional-agencies' },
    { k: ['sport','sports','sponsorship','stadium'], label: 'Sports & sponsorships', url: '/pages/sports-sponsorships' },
    { k: ['music','festival','festivals','concert'], label: 'Music & festivals', url: '/pages/music-festivals' },
    { k: ['brew','brewing','beverage','beer','drink'], label: 'Brewing & beverage', url: '/pages/brewing-beverage' },
    { k: ['artist','artists','fashion','art'], label: 'Artists & fashion', url: '/pages/artists-fashion' },
    { k: ['industrial','solution','solutions','commercial'], label: 'Industrial solutions', url: '/pages/industrial-solutions' },
    { k: ['case stud','portfolio','examples','past work','projects'], label: 'Case studies', url: '/pages/case-studies' },
    { k: ['studio','about','team','who are you','about you'], label: 'Our studio', url: '/pages/studio' },
    { k: ['blog','article','articles','read','news'], label: 'Blog', url: '/blogs/news' },
  ];

  var faqData = [
    { k: ['price','cost','how much','pricing','charge','budget','quote'], a: "Every project is custom, so pricing depends on size, complexity, quantity, and materials. We'll get you a detailed quote within 24 hours.\n\nTell us what you have in mind and we'll take it from there." },
    { k: ['long','time','timeline','turnaround','delivery','when','fast','rush'], a: "Most projects are completed in **15 to 40 days** depending on size, design and quantity.\n\nNeed it faster? Rush orders are our specialty. Just let us know your deadline." },
    { k: ['material','pvc','durable','quality','waterproof','heavy duty'], a: "Thicker material, stronger seams. Built to survive a festival, a retail launch, or a three-day stadium install.\n\nEvery unit is rigorously tested for 24 hours before it leaves our facility." },
    { k: ['process','how does it work','steps','work','begin','get started'], a: "Three steps:\n\n**01. The Idea.** Send us a logo, a napkin sketch, or just describe it.\n\n**02. The Blueprint.** We build a production-ready 3D render. Free, no commitment.\n\n**03. The Reality.** Manufactured, quality-checked, and shipped worldwide." },
    { k: ['minimum','moq','one','single','small order','just one'], a: "**No minimum order.** One piece or a fleet of hundreds, same quality, same process.\n\nTell us what you need and we'll make it happen." },
    { k: ['ship','shipping','deliver','international','worldwide'], a: "We ship worldwide. **3-5 business days** after production wraps. We handle all the logistics so you don't have to." },
    { k: ['client','who','worked with','brand','portfolio'], a: "Nike, Disney, YouTube, Netflix, Spotify, Google, Tesla, and a lot more.\n\nWant to see the work? Check out our [case studies](/pages/case-studies)." },
    { k: ['size','how big','large','dimensions','feet'], a: "From tabletop pieces to **20ft+ landmarks**. It depends on your vision and where it'll be deployed.\n\nGive us the details and we'll figure out the rest." },
    { k: ['mockup','render','3d','design','preview'], a: "Every project includes a **free 3D mockup** before anything is manufactured. You approve the design, no surprises." },
    { k: ['festival','event','outdoor','weather'], a: "Commercial-grade, built for heavy outdoor use. Festivals, trade shows, high-traffic environments.\n\nSee how we've done it: [music & festivals](/pages/music-festivals)." },
    { k: ['hello','hi','hey','sup','yo'], a: "Hey, welcome to Floatie Kings.\n\nWhat can we help you create?" },
    { k: ['thank','thanks','awesome','great','perfect'], a: "Anytime. Anything else you want to know?" },
  ];

  /* Generic fallback — when nothing in the FAQ/page keywords matches, don't
     bluff an answer. Hand the visitor to a real person three ways: the custom
     quote form, a call, or an email. Phone/email come from section settings so
     the copy stays in sync with the footer. */
  var contactPhone = widget.getAttribute('data-contact-phone') || '';
  var contactEmail = widget.getAttribute('data-contact-email') || '';
  var telHref = 'tel:' + contactPhone.replace(/[^0-9+]/g, '');

  function buildDefaultAnswer() {
    var lines = [
      "Good question — and the kind that deserves a real answer, not a guess.",
      "",
      "Every build is different, so the fastest way to get it right is to put it in front of the studio. Three ways, whichever's easiest:",
      "",
      "**[Fill out a custom quote](#quote-form)** — tell us the essentials and we'll come back within 24 hours with real numbers.",
    ];
    if (contactPhone) lines.push("**[Give us a call](" + telHref + ")** — talk it through with us right now.");
    if (contactEmail) lines.push("**[Send us an email](mailto:" + contactEmail + ")** — drop the details and we'll reply personally.");
    lines.push("");
    lines.push("Whatever you're picturing, we'd love to build it with you.");
    return lines.join("\n");
  }

  var defaultAnswer = buildDefaultAnswer();

  /* The fallback "fill out a custom quote" link points at #quote-form — open the
     in-widget form instead of navigating away. (tel:/mailto: links pass through.) */
  if (messagesEl) {
    messagesEl.addEventListener('click', function(e) {
      var link = e.target.closest && e.target.closest('a[href="#quote-form"]');
      if (!link) return;
      e.preventDefault();
      showForm();
    });
  }
  var greeting = widget.getAttribute('data-chat-greeting') || "Hey! I’m here to help. What are you working on?";

  function findAnswer(t) {
    var l = t.toLowerCase();

    /* Check FAQ first */
    for (var i = 0; i < faqData.length; i++)
      for (var j = 0; j < faqData[i].k.length; j++)
        if (l.indexOf(faqData[i].k[j]) !== -1) return faqData[i].a;

    /* Check page routes - if someone asks about a topic, link them */
    for (var r = 0; r < pageRoutes.length; r++)
      for (var s = 0; s < pageRoutes[r].k.length; s++)
        if (l.indexOf(pageRoutes[r].k[s]) !== -1)
          return "We'd love to tell you more. Check out our [" + pageRoutes[r].label + "](" + pageRoutes[r].url + ") page.\n\nOr if you have something specific in mind, just describe it and we'll get you a quote.";

    return defaultAnswer;
  }

  /* ── Render (DM-style — bubbles + name/time meta on bot side) ── */
  var chatPersonaName = widget.getAttribute('data-chat-persona-name') || 'Sam';

  function formatBubbleText(text, sender) {
    var safe = sender === 'user' ? escapeHtml(text) : text;
    return safe
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\[(.+?)\]\((.+?)\)/g, function(m, label, url) {
        return '<a href="' + escapeHtml(url) + '" class="quote-widget__link">' + escapeHtml(label) + '</a>';
      })
      .replace(/\n/g, '<br>');
  }

  function formatTime(date) {
    return date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0');
  }

  function buildMeta() {
    var meta = document.createElement('div');
    meta.className = 'quote-widget__msg-meta';
    var name = document.createElement('span');
    name.className = 'quote-widget__msg-name';
    name.textContent = chatPersonaName;
    var time = document.createElement('span');
    time.className = 'quote-widget__msg-time';
    time.textContent = formatTime(new Date());
    meta.appendChild(name);
    meta.appendChild(time);
    return meta;
  }

  function addMessage(text, sender) {
    var msg = document.createElement('div');
    msg.className = 'quote-widget__msg quote-widget__msg--' + sender;

    if (sender === 'bot') {
      msg.appendChild(buildMeta());
    }

    var bubble = document.createElement('div');
    bubble.className = 'quote-widget__msg-bubble';
    bubble.innerHTML = formatBubbleText(text, sender);
    msg.appendChild(bubble);

    messagesEl.appendChild(msg);
    content.scrollTop = content.scrollHeight;
    if (g() && !prefersReducedMotion) gsap.from(msg, { autoAlpha: 0, y: 10, duration: 0.3, ease: 'power2.out' });
  }

  function showTyping() {
    var msg = document.createElement('div');
    msg.className = 'quote-widget__msg quote-widget__msg--bot quote-widget__msg--typing';
    msg.id = 'quote-typing';

    var bubble = document.createElement('div');
    bubble.className = 'quote-widget__msg-bubble quote-widget__msg-bubble--typing';
    bubble.innerHTML = '<span class="quote-widget__typing-dots"><span></span><span></span><span></span></span>';
    msg.appendChild(bubble);

    messagesEl.appendChild(msg);
    content.scrollTop = content.scrollHeight;
    if (g() && !prefersReducedMotion) gsap.from(msg, { autoAlpha: 0, y: 10, duration: 0.25, ease: 'power2.out' });
  }

  function hideTyping() { var el = document.getElementById('quote-typing'); if (el) el.remove(); }

  /* Chat history is maintained client-side and sent with every API request so the
     model has context. Capped server-side as well; here we don't trim. */
  var chatApiUrl = widget.getAttribute('data-chat-api-url') || '';
  var chatHistory = [];
  var chatInFlight = false;

  /* Create an empty bot bubble whose text fills as the stream arrives. */
  function addStreamingBotMessage() {
    var msg = document.createElement('div');
    msg.className = 'quote-widget__msg quote-widget__msg--bot';
    msg.appendChild(buildMeta());

    var bubble = document.createElement('div');
    bubble.className = 'quote-widget__msg-bubble';
    msg.appendChild(bubble);

    messagesEl.appendChild(msg);
    content.scrollTop = content.scrollHeight;
    if (g() && !prefersReducedMotion) gsap.from(msg, { autoAlpha: 0, y: 10, duration: 0.3, ease: 'power2.out' });

    return bubble;
  }

  function streamFromApi() {
    chatInFlight = true;
    showTyping();

    fetch(chatApiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: chatHistory }),
    }).then(function(res) {
      if (!res.ok || !res.body) throw new Error('chat API ' + res.status);
      hideTyping();
      var bubble = addStreamingBotMessage();
      var reader = res.body.getReader();
      var decoder = new TextDecoder();
      var fullText = '';

      function pump() {
        return reader.read().then(function(result) {
          if (result.done) {
            chatHistory.push({ role: 'assistant', content: fullText });
            chatInFlight = false;
            return;
          }
          fullText += decoder.decode(result.value, { stream: true });
          bubble.innerHTML = formatBubbleText(fullText, 'bot');
          content.scrollTop = content.scrollHeight;
          return pump();
        });
      }
      return pump();
    }).catch(function(err) {
      if (window.console) console.error('Chat API error:', err);
      hideTyping();
      addMessage("I'm having trouble responding right now. Tap **Quote** above to send your details and we'll come back within 24 hours.", 'bot');
      chatInFlight = false;
    });
  }

  function handleSend() {
    if (chatInFlight) return;
    var text = inputField.value.trim();
    if (!text) return;

    if (isFormRequest(text)) {
      inputField.value = '';
      showForm();
      return;
    }

    if (chipsEl && chipsEl.style.display !== 'none') {
      if (g()) gsap.to(chipsEl, { autoAlpha: 0, height: 0, duration: 0.2, onComplete: function() { chipsEl.style.display = 'none'; } });
      else chipsEl.style.display = 'none';
    }
    addMessage(text, 'user');
    chatHistory.push({ role: 'user', content: text });
    inputField.value = '';

    if (chatApiUrl) {
      streamFromApi();
    } else {
      showTyping();
      var answer = findAnswer(text);
      chatHistory.push({ role: 'assistant', content: answer });
      setTimeout(function() { hideTyping(); addMessage(answer, 'bot'); }, 500 + Math.random() * 600);
    }
  }

  /* ── File attachments (up to 3) ──
     A JS-managed list is the source of truth (not input.files), because the
     native input can't accumulate across multiple picks or enforce a max. The
     add button opens the picker only while under the limit; picking more than
     the remaining slots keeps the first ones and flashes a "max reached" note. */
  var MAX_FILES = 3;
  var fileBlock = widget.querySelector('[data-file-block]');
  var fileInput = widget.querySelector('[data-file-input]');
  var fileAddBtn = widget.querySelector('[data-file-add]');
  var fileListEl = widget.querySelector('[data-file-list]');
  var fileLimitMsg = widget.querySelector('[data-file-limit]');
  var fileRemoveLabel = fileBlock ? fileBlock.getAttribute('data-file-remove-label') : 'Remove file';
  var selectedFiles = [];
  var fileLimitTimer = null;

  /* Upload each file to Blob the MOMENT it's attached (not at submit) so the
     images are already hosted by the time the user hits send — image submits
     then feel instant instead of waiting on the upload. Each file's upload
     promise is cached; submit just awaits them. The Blob client module is
     fetched lazily once and reused, and warmed when the picker opens. */
  var blobClientPromise = null;
  function loadBlobClient() {
    if (!blobClientPromise) blobClientPromise = import('https://esm.sh/@vercel/blob@2/client');
    return blobClientPromise;
  }
  var blobUploadUrl = (widget.getAttribute('data-quote-webhook-url') || '').replace(/\/api\/leads\/?$/, '/api/upload');
  var uploads = new Map(); /* File -> { status, promise<{url,name}> } */
  function ensureUpload(file) {
    var entry = uploads.get(file);
    if (entry && entry.status !== 'error') return entry.promise;
    entry = { status: 'pending', promise: null };
    entry.promise = loadBlobClient()
      .then(function(blob) {
        return blob.upload('fk-leads/' + file.name, file, {
          access: 'public',
          handleUploadUrl: blobUploadUrl,
          contentType: file.type || undefined,
        });
      })
      .then(
        function(b) { entry.status = 'done'; return { url: b.url, name: file.name }; },
        function(err) { entry.status = 'error'; throw err; }
      );
    uploads.set(file, entry);
    return entry.promise;
  }

  function flashFileLimit() {
    if (!fileLimitMsg) return;
    fileLimitMsg.hidden = false;
    if (fileLimitTimer) clearTimeout(fileLimitTimer);
    fileLimitTimer = setTimeout(function() { fileLimitMsg.hidden = true; }, 4000);
  }

  function updateFileAddState() {
    if (fileAddBtn) fileAddBtn.disabled = selectedFiles.length >= MAX_FILES;
  }

  function renderFileList() {
    if (!fileListEl) return;
    fileListEl.textContent = '';
    selectedFiles.forEach(function(file) {
      var li = document.createElement('li');
      li.className = 'quote-widget__file-item';

      var name = document.createElement('span');
      name.className = 'quote-widget__file-name';
      name.textContent = file.name;

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'quote-widget__file-remove';
      remove.setAttribute('aria-label', fileRemoveLabel);
      remove.innerHTML = '&times;';
      remove.addEventListener('click', function() {
        var idx = selectedFiles.indexOf(file);
        if (idx > -1) selectedFiles.splice(idx, 1);
        uploads.delete(file); /* drop its in-flight/finished upload */
        if (fileLimitMsg) fileLimitMsg.hidden = true;
        renderFileList();
        updateFileAddState();
      });

      li.appendChild(name);
      li.appendChild(remove);
      fileListEl.appendChild(li);
    });
  }

  function resetFiles() {
    selectedFiles = [];
    uploads.clear();
    if (fileLimitMsg) fileLimitMsg.hidden = true;
    renderFileList();
    updateFileAddState();
  }

  if (fileAddBtn && fileInput) {
    fileAddBtn.addEventListener('click', function() {
      if (selectedFiles.length >= MAX_FILES) { flashFileLimit(); return; }
      if (blobUploadUrl) loadBlobClient(); /* warm the Blob client while the picker is open */
      fileInput.click();
    });
    fileInput.addEventListener('change', function() {
      var incoming = Array.prototype.slice.call(fileInput.files);
      var overflowed = false;
      incoming.forEach(function(file) {
        if (selectedFiles.length < MAX_FILES) {
          selectedFiles.push(file);
          if (blobUploadUrl) ensureUpload(file); /* start uploading right away */
        } else overflowed = true;
      });
      if (overflowed) flashFileLimit();
      fileInput.value = ''; /* let the same file be re-picked / fire change again */
      renderFileList();
      updateFileAddState();
    });
  }

  /* ── Quote form submission → Customs OS webhook ── */
  var quoteWebhookUrl = widget.getAttribute('data-quote-webhook-url') || '';
  var quoteDualFire = widget.getAttribute('data-quote-dual-fire') === 'true';
  var quoteForm = formView ? formView.querySelector('form') : null;
  /* Neutralize the native action. Shopify's contact form tag points at
     /contact, and SOMETHING outside our handler (a Shopify app, a browser
     extension, a stray form.submit()) was still triggering a native POST that
     reloaded the page to ?contact_posted=true#contact_form even though our
     submit handler calls preventDefault. preventDefault can't stop a
     programmatic submit — but a form whose action is javascript:void(0) simply
     cannot navigate. We submit purely via fetch below, so this changes nothing
     about the real flow. */
  if (quoteForm) quoteForm.setAttribute('action', 'javascript:void(0)');
  var quoteSubmitBtn = formView ? formView.querySelector('[data-quote-submit]') : null;
  var quoteRetryBtn = formView ? formView.querySelector('[data-quote-form-retry]') : null;
  var quoteStages = formView ? formView.querySelectorAll('[data-quote-form-stage]') : [];
  var quoteSubmitLabelEl = quoteSubmitBtn ? quoteSubmitBtn.querySelector('[data-text-stagger]') : null;
  var quoteSubmitSendingEl = quoteSubmitBtn ? quoteSubmitBtn.querySelector('[data-quote-submit-sending]') : null;

  /* Stable id for one logical submission. Generated on first send, reused on
     retries (so a network retry dedupes upstream), cleared after success so
     the next genuine submission gets a fresh id. revenue-os dedupes on
     (brand_id, source, source_entry_id). */
  var quoteSubmissionId = null;
  function getQuoteSubmissionId() {
    if (!quoteSubmissionId) {
      if (window.crypto && window.crypto.randomUUID) {
        quoteSubmissionId = window.crypto.randomUUID();
      } else {
        quoteSubmissionId = 'fk-' + Date.now() + '-' + Math.random().toString(16).slice(2);
      }
    }
    return quoteSubmissionId;
  }

  function setQuoteStage(stage) {
    for (var s = 0; s < quoteStages.length; s++) {
      quoteStages[s].hidden = quoteStages[s].getAttribute('data-quote-form-stage') !== stage;
    }
  }

  function setQuoteSubmitting(isSubmitting) {
    if (!quoteSubmitBtn) return;
    quoteSubmitBtn.disabled = isSubmitting;
    /* Toggle the two label spans instead of rewriting textContent, which
       would destroy the text-stagger markup built by text-stagger.js. */
    if (quoteSubmitLabelEl) quoteSubmitLabelEl.hidden = isSubmitting;
    if (quoteSubmitSendingEl) quoteSubmitSendingEl.hidden = !isSubmitting;
  }

  function onQuoteSuccess() {
    setQuoteStage('success');

    /* Lead-conversion tracking (Echelon integration): publish the submitted
       lead to the Shopify analytics pixel bus. Preserved from the live theme. */
    var emailField = quoteForm.querySelector('[name="contact[email]"]');
    var phoneField = quoteForm.querySelector('[name="contact[phone]"]');
    Shopify.analytics.publish('echelonn:lead_submitted', {
      email: emailField ? emailField.value.trim().toLowerCase() : '',
      phone: phoneField ? phoneField.value.trim() : ''
    });

    /* Koast/Whop conversion pixel (steps 2 and 3 of their install). identify()
       first so the visit can be matched to the person, then the funnel event.
       A submitted quote request is Koast's "lead" event — this is the site's
       primary conversion.

       Guarded on window.whop because the loader is skipped inside the theme
       editor (request.design_mode), where the global would not exist. Wrapped
       in try/catch so a pixel failure can never break the success screen the
       customer is looking at. */
    try {
      if (window.whop) {
        var whopEmail = emailField ? emailField.value.trim().toLowerCase() : '';
        if (whopEmail && window.fkWhopIdentify) fkWhopIdentify(whopEmail);
        whop.track('lead');
      }
    } catch (err) {
      if (window.console) console.error('Whop lead event failed:', err);
    }

    quoteForm.reset();
    quoteSubmissionId = null; /* fresh id for the next genuine submission */
    resetFiles();
  }

  if (quoteForm) {
    quoteForm.addEventListener('submit', function(e) {
      /* Always intercept. The Shopify contact form would otherwise do a native
         full-page POST — reloading to #contact_form (scrolling the page to the
         footer) and closing the modal. We keep the modal open and show the
         in-modal success stage on every path. */
      e.preventDefault();
      setQuoteSubmitting(true);

      if (quoteWebhookUrl) {
        /* Primary path: Customs OS proxy. Up to 3 attachments (selectedFiles). */
        function sendLead(attachments, failedNames) {
          var payload = new FormData(quoteForm);
          /* Don't send the raw file bytes through the proxy — Vercel functions
             cap the request body at ~4.5MB. We upload each file straight to Blob
             (below) and forward only the hosted URLs. */
          payload.delete('contact[attachment]');
          if (attachments && attachments.length) {
            payload.append('attachment_urls', JSON.stringify(attachments));
            /* Back-compat: also send the first as the original single fields. */
            payload.append('attachment_url', attachments[0].url);
            payload.append('attachment_name', attachments[0].name);
          }
          /* A failed attachment upload (e.g. Blob storage full) must NEVER lose
             the lead. Send it anyway and flag which files didn't make it so sales
             can ask the customer to re-send them. */
          if (failedNames && failedNames.length) {
            payload.append('attachment_upload_failed', 'true');
            payload.append('attachment_failed_names', failedNames.join(', '));
          }
          payload.append('attribution', JSON.stringify(window.fkAttribution || {}));
          payload.append('source', 'website-modal');
          payload.append('source_entry_id', getQuoteSubmissionId());
          payload.append('schema_version', '1.0');
          payload.append('submitted_at', new Date().toISOString());
          payload.append('page_url', window.location.href);
          /* Entry (first-touch) landing page + referrer for every lead, all
             channels — GA4-independent per-page + non-paid channel attribution.
             entry_landing_page is the path-only join key; never blank. */
          var fkEntry = window.fkEntry || {};
          payload.append('entry_landing_page', fkEntry.landing_page || window.location.pathname);
          payload.append('entry_referrer', fkEntry.referrer || '');
          payload.append('entry_landing_url', fkEntry.landing_url || window.location.href);
          /* Device bucket — GA4's own desktop/mobile/tablet split so conversion-by
             -device lines up with GA4's session-by-device numbers. */
          var fkUA = navigator.userAgent || '';
          var fkIsIPad = /iPad/.test(fkUA) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
          var fkDevice = 'desktop';
          if (fkIsIPad || (/Android/.test(fkUA) && !/Mobile/.test(fkUA)) || /Tablet|PlayBook|Silk/.test(fkUA)) fkDevice = 'tablet';
          else if (/Mobi|iPhone|iPod|Windows Phone|BlackBerry|Opera Mini/.test(fkUA)) fkDevice = 'mobile';
          payload.append('device', fkDevice);
          /* NorthStar ad-click ids + UTMs (window.nsLead, from the NorthStar snippet).
             Fill blanks only: anything the form/widget already sent wins. This is
             a FormData body, so `utm` goes as a JSON string. Never blocks submit. */
          try {
            if (typeof window.nsLead === 'function') {
              var ns = window.nsLead() || {};
              ['gclid', 'gbraid', 'wbraid', 'fbclid', 'fbc', 'msclkid', 'ttclid', 'entry_landing_url', 'entry_referrer', 'ns_visitor'].forEach(function(k) {
                if (ns[k] && !payload.get(k)) payload.set(k, ns[k]);
              });
              if (ns.utm && Object.keys(ns.utm).length && !payload.get('utm')) payload.set('utm', JSON.stringify(ns.utm));
            }
          } catch (nsErr) {
            if (window.console) console.error('nsLead merge failed:', nsErr);
          }

          return fetch(quoteWebhookUrl, { method: 'POST', body: payload })
            .then(function(res) {
              if (!res.ok) throw new Error('webhook ' + res.status);
              onQuoteSuccess();
            });
        }

        var chain;
        if (selectedFiles.length) {
          /* Files began uploading to Blob the moment they were attached (see
             ensureUpload). We await them, but with allSettled — a failed upload
             (e.g. Blob storage full) must NOT reject the whole submit and lose
             the lead. Send with whatever uploaded; flag the rest for follow-up. */
          chain = Promise.allSettled(selectedFiles.map(ensureUpload))
            .then(function(results) {
              var attachments = [];
              var failedNames = [];
              results.forEach(function(r, i) {
                if (r.status === 'fulfilled' && r.value) {
                  attachments.push(r.value);
                } else {
                  failedNames.push((selectedFiles[i] && selectedFiles[i].name) || 'file');
                }
              });
              return sendLead(attachments, failedNames);
            });
        } else {
          chain = sendLead([], []);
        }

        chain
          .catch(function(err) {
            if (window.console) console.error('Quote submit failed:', err);
            setQuoteStage('error');
          })
          .then(function() { setQuoteSubmitting(false); });
      } else {
        /* Fallback path: no webhook configured. Submit to Shopify's contact form
           over fetch (best-effort) so the lead is still emailed — without the
           native page navigation that would close the modal. */
        fetch('/contact', { method: 'POST', body: new FormData(quoteForm) })
          .then(function() { onQuoteSuccess(); })
          .catch(function(err) {
            if (window.console) console.error('Contact fallback failed:', err);
            setQuoteStage('error');
          })
          .then(function() { setQuoteSubmitting(false); });
      }
    });
  }

  if (quoteRetryBtn) {
    quoteRetryBtn.addEventListener('click', function() {
      setQuoteStage('form');
    });
  }

  /* ── Chips ── */
  var chips = widget.querySelectorAll('[data-chat-chip]');
  for (var i = 0; i < chips.length; i++) chips[i].addEventListener('click', function() { inputField.value = this.textContent; handleSend(); });

  function setActiveTab(name) {
    for (var t = 0; t < tabs.length; t++) {
      if (tabs[t].dataset.tab === name) tabs[t].classList.add('is-active');
      else tabs[t].classList.remove('is-active');
    }
  }

  /* Smoothly animate the widget size (width AND height) when switching tabs.
     We lock the current pixel size inline, swap the class so CSS resolves
     the new target, measure, then tween current → target.
     Kills openTl since its recorded end-size no longer matches the DOM. */
  var sizeTween = null;
  var tabSwitching = false;

  function animateSizeSwitch(toForm) {
    if (openTl) { openTl.kill(); openTl = null; }
    if (sizeTween) { sizeTween.kill(); sizeTween = null; }

    var currentW = widget.offsetWidth;
    var currentH = widget.offsetHeight;

    if (toForm) widget.classList.add('is-form');
    else widget.classList.remove('is-form');

    widget.style.width = '';
    widget.style.height = '';
    var targetW = widget.offsetWidth;
    var targetH = widget.offsetHeight;

    if (!g() || prefersReducedMotion) return;

    widget.style.width = currentW + 'px';
    widget.style.height = currentH + 'px';

    sizeTween = gsap.to(widget, {
      width: targetW,
      height: targetH,
      duration: 0.5,
      ease: 'power2.inOut',
      onComplete: function() {
        sizeTween = null;
        widget.style.width = '';
        widget.style.height = '';
      },
    });
  }

  function showForm() {
    if (widget.classList.contains('is-form') || tabSwitching) return;
    setActiveTab('form');
    /* Apply modal state — backdrop + scroll lock — fade is handled by CSS transition */
    if (backdrop) backdrop.classList.add('is-visible');
    document.documentElement.classList.add('quote-modal-open');

    if (!g() || prefersReducedMotion) {
      animateSizeSwitch(true);
      return;
    }

    /* Fade the chat view out, resize the shell, fade the form in. */
    tabSwitching = true;
    var outgoing = [content, inputRow];
    gsap.to(outgoing, {
      autoAlpha: 0, duration: 0.18, ease: 'power2.in',
      onComplete: function() {
        tabSwitching = false;
        animateSizeSwitch(true);
        gsap.set(outgoing, { clearProps: 'opacity,visibility' });

        var fields = formView.querySelectorAll('input, textarea, .quote-widget__file-row, .quote-widget__form-submit, .quote-widget__form-intro, .quote-widget__form-logos');
        gsap.fromTo(formView, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3, ease: 'power2.out', delay: 0.15 });
        gsap.fromTo(fields, { autoAlpha: 0, y: 12 }, {
          autoAlpha: 1, y: 0, duration: 0.35, ease: 'power2.out',
          stagger: 0.04, delay: 0.2,
        });
      },
    });
  }

  function showChat() {
    if (!widget.classList.contains('is-form') || tabSwitching) return;
    setActiveTab('chat');
    /* Release modal state — backdrop fades out via CSS, scroll unlocks */
    if (backdrop) backdrop.classList.remove('is-visible');
    document.documentElement.classList.remove('quote-modal-open');

    if (!g() || prefersReducedMotion) {
      animateSizeSwitch(false);
      return;
    }

    /* Fade the form out, resize the shell, fade the chat view in. */
    tabSwitching = true;
    gsap.to(formView, {
      autoAlpha: 0, duration: 0.18, ease: 'power2.in',
      onComplete: function() {
        tabSwitching = false;
        animateSizeSwitch(false);
        gsap.set(formView, { clearProps: 'opacity,visibility' });
        gsap.fromTo([content, inputRow], { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3, ease: 'power2.out', delay: 0.15 });
      },
    });
  }

  if (skipFormBtn) skipFormBtn.addEventListener('click', showForm);
  if (backBtn) backBtn.addEventListener('click', showChat);

  /* ── Tabs ── */
  var tabs = widget.querySelectorAll('.quote-widget__tab');
  for (var t = 0; t < tabs.length; t++) {
    tabs[t].addEventListener('click', function() {
      if (this.dataset.tab === 'form') showForm();
      else showChat();
    });
  }

  var formKeywords = ['form', 'inquiry', 'quote form', 'contact form', 'submit', 'fill out', 'fill in', 'send details', 'send my details', 'enquiry', 'custom quote', 'get a quote', 'request a quote', 'start a quote'];

  function isFormRequest(text) {
    var l = text.toLowerCase();
    for (var i = 0; i < formKeywords.length; i++) {
      if (l.indexOf(formKeywords[i]) !== -1) return true;
    }
    return false;
  }

  sendBtn.addEventListener('click', handleSend);
  inputField.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); handleSend(); } });

  /* ═══════════════════════════════════════════
     OPEN — one clean GSAP timeline
     Step 1: pill label fades out
     Step 2: pill expands to panel, content fades in
     ═══════════════════════════════════════════ */

  inputRow.addEventListener('click', function() { if (!isOpen) { triggerEl = inputRow; openWidget(true); } });
  document.addEventListener('click', function(e) {
    /* Also catch the legacy quote trigger in older product descriptions
       (<a href="#modal-open">here</a>) so it opens the new modal too. */
    var btn = e.target.closest('[data-open="quote-modal"], a[href="#modal-open"]');
    if (btn) { e.preventDefault(); triggerEl = btn; openWidget(true); }
  });

  /* Open straight from a link, e.g. an email "Start your project" button.
     Works on any page:
       ?quote=open   preferred for email: survives click-tracking redirects
                     and sits alongside UTM tags
       #quote        short alternative
       #modal-open   old links in product descriptions
     The marker is removed from the address bar once read, so a refresh,
     back button or shared link doesn't pop the modal open again; any other
     query params (UTMs) are kept. Opens after a short beat so the page has
     painted first. */
  (function() {
    var params = new URLSearchParams(window.location.search);
    var hash = window.location.hash;
    var fromQuery = params.get('quote') === 'open';
    var fromHash = hash === '#quote' || hash === '#modal-open';
    if (!fromQuery && !fromHash) return;

    if (fromQuery) params.delete('quote');
    var query = params.toString();
    var cleanUrl = window.location.pathname + (query ? '?' + query : '') + (fromHash ? '' : hash);
    history.replaceState(history.state, '', cleanUrl);

    setTimeout(function() { openWidget(true); }, 600);
  })();

  function openWidget(openToForm) {
    if (isAnimating || isOpen) return;
    isOpen = true;
    isAnimating = true;
    if (entranceTween) { entranceTween.kill(); entranceTween = null; }
    /* The pill may be hidden (over the hero) when opened via a CTA button —
       make sure it's visible so the open animation actually shows. */
    pillRevealed = true;
    if (g()) gsap.set(widget, { autoAlpha: 1, y: 0 });
    else { widget.style.opacity = '1'; widget.style.visibility = 'visible'; }
    if (openToForm) {
      setActiveTab('form');
    } else {
      setActiveTab('chat');
    }

    /* 1. Measure pill */
    pillW = widget.offsetWidth;
    pillH = widget.offsetHeight;
    var pillStyles = getComputedStyle(widget);
    var pillBot = parseFloat(pillStyles.bottom);
    var pillRight = parseFloat(pillStyles.right);
    var pillPad = getComputedStyle(inputRow).padding;

    /* Pre-hide the send button BEFORE the class swap so it never paints visible.
       (Without this, .is-open flips display: none → flex with default opacity 1,
       and the CSS transition fights GSAP's initial set.) */
    if (g() && !prefersReducedMotion && !openToForm) {
      gsap.set(sendBtn, { opacity: 0, scale: 0.85 });
    }

    /* 2. Add .is-open for display toggling, then measure expanded */
    widget.classList.add('is-open');
    if (openToForm) widget.classList.add('is-form');
    if (!messagesEl.children.length) {
      addMessage(greeting, 'bot');
      chatHistory.push({ role: 'assistant', content: greeting });
    }

    var ecs = getComputedStyle(widget);
    var expandedW = widget.offsetWidth;
    var expandedBot = parseFloat(ecs.bottom);
    var expandedRight = parseFloat(ecs.right);
    /* offsetHeight reflects whichever mode is active (form = full, chat = content-fit) */
    var targetH = widget.offsetHeight;

    var expandedPad;
    if (!openToForm) {
      expandedPad = getComputedStyle(inputRow).padding;
    }

    /* Backdrop + scroll lock only when opening to the Quote/form tab.
       Chat keeps the page interactive and skips the dimmer. */
    if (openToForm) {
      if (backdrop) backdrop.classList.add('is-visible');
      document.documentElement.classList.add('quote-modal-open');
    }

    if (!g() || prefersReducedMotion) {
      isAnimating = false;
      if (!openToForm) inputField.focus();
      return;
    }

    /* 3. Lock to pill state */
    /* #010101 = --color-surface-dark-deep, transparent border = pill has none */
    /* will-change deliberately omits background-color: on iOS, promoting a layer
       for a background-color change flashes one frame of the element's CSS
       background (the .is-open white) before GSAP's inline black composites. */
    gsap.set(widget, { width: pillW, height: pillH, bottom: pillBot, right: pillRight, borderRadius: 12, overflow: 'hidden', backgroundColor: '#010101', borderColor: 'rgba(0, 0, 0, 0)', willChange: 'width, height' });
    gsap.set(topbar, { opacity: 0, visibility: 'hidden' });

    if (openToForm) {
      gsap.set(formView, { opacity: 0 });
    } else {
      /* Lock the input row to its collapsed visual state so the pill styles
         (margin, background, border, radius) morph in smoothly instead of snapping. */
      gsap.set(inputRow, {
        padding: pillPad,
        margin: 0,
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 0
      });
      /* Keep the dot icon visible at the start of the animation, then GSAP collapses it */
      gsap.set(dotIcon, { width: dotIcon.offsetWidth || 44, marginRight: 0, opacity: 1, overflow: 'hidden' });
      gsap.set(content, { opacity: 0, visibility: 'hidden' });
      gsap.set(inputField, { opacity: 0 });
      /* sendBtn already pre-hidden above before classList.add — no need to repeat */
    }

    /* 4. Timeline */
    openTl = gsap.timeline({
      paused: true,
      onComplete: function() {
        isAnimating = false;
        gsap.set(widget, { clearProps: 'width,height,bottom,right,borderRadius,overflow,backgroundColor,borderColor,willChange' });
        gsap.set(topbar, { clearProps: 'opacity,visibility' });
        gsap.set(pillLabel, { clearProps: 'opacity,visibility' });
        if (openToForm) {
          gsap.set(formView, { clearProps: 'opacity' });
        } else {
          gsap.set(inputRow, { clearProps: 'padding,margin,backgroundColor,borderColor,borderWidth,borderStyle,borderRadius' });
          gsap.set(dotIcon, { clearProps: 'width,marginRight,opacity,overflow' });
          gsap.set(content, { clearProps: 'opacity,visibility' });
          gsap.set(inputField, { clearProps: 'opacity' });
          gsap.set(sendBtn, { clearProps: 'opacity,scale' });
          inputField.focus();
        }
      },
      onReverseComplete: function() {
        isOpen = false;
        isAnimating = false;
        widget.classList.remove('is-open', 'is-form');
        gsap.set(widget, { clearProps: 'all' });
        gsap.set(inputRow, { clearProps: 'all' });
        gsap.set(dotIcon, { clearProps: 'all' });
        gsap.set(content, { clearProps: 'all' });
        gsap.set(topbar, { clearProps: 'all' });
        gsap.set(pillLabel, { clearProps: 'all' });
        gsap.set(inputField, { clearProps: 'all' });
        gsap.set(sendBtn, { clearProps: 'all' });
        if (formView) gsap.set(formView, { clearProps: 'all' });
        /* clearProps made the pill visible again — re-check scroll so it hides
           if we closed while still over the hero. */
        pillRevealed = true;
        onRevealScroll();
        if (triggerEl) { triggerEl.focus(); triggerEl = null; }
      },
    });

    /* ── One cohesive morph ──
       The container grow is the spine of the motion. The pill face (label + dot)
       clears in the first ~0.2s as the box starts growing; the panel contents
       resolve TOGETHER in the last third so they land as the box settles, instead
       of popping in at scattered times. autoAlpha (not visibility keyframes) so
       nothing snaps in/out. Because close just reverses this timeline, it inherits
       the same choreography in reverse: contents fade out first, the box collapses,
       and the pill face returns at the very end. */
    var MORPH = 0.54;
    var MORPH_EASE = 'power3.out';

    /* Pill face fades out as the grow begins */
    openTl.to(pillLabel, { autoAlpha: 0, duration: 0.15, ease: 'power2.in' }, 0);

    /* Spine: the pill expands into the panel */
    openTl.to(widget, {
      width: expandedW, height: targetH,
      bottom: expandedBot, right: expandedRight,
      backgroundColor: '#ffffff', borderColor: '#e0e0e0',
      duration: MORPH, ease: MORPH_EASE,
    }, 0.04);

    if (openToForm) {
      openTl.to(formView, { autoAlpha: 1, duration: 0.24, ease: 'power2.out' }, 0.3);
    } else {
      /* Dot icon collapses with the label. opacity (not autoAlpha) so it matches
         the onComplete clearProps and isn't left visibility:hidden in the panel. */
      openTl.to(dotIcon, { width: 0, opacity: 0, duration: 0.2, ease: 'power2.inOut' }, 0);

      /* Input row morphs from flat pill row → rounded floating input, with the box */
      openTl.to(inputRow, {
        padding: expandedPad,
        margin: '8px 16px 16px',
        backgroundColor: 'rgba(0, 0, 0, 0.06)',
        borderColor: 'rgba(0, 0, 0, 0.1)',
        borderRadius: 999,
        duration: MORPH, ease: MORPH_EASE,
      }, 0.04);

      /* Panel contents resolve together at the tail, as the box settles */
      openTl.to(content, { autoAlpha: 1, duration: 0.24, ease: 'power2.out' }, 0.28);
      openTl.to(inputField, { autoAlpha: 1, duration: 0.22, ease: 'power2.out' }, 0.3);
      openTl.to(sendBtn, { autoAlpha: 1, scale: 1, duration: 0.24, ease: 'power2.out' }, 0.32);
    }

    openTl.to(topbar, { autoAlpha: 1, duration: 0.22, ease: 'power2.out' }, 0.3);

    openTl.play();
  }

  /* ═══════════════════════════════════════════
     CLOSE — just reverse the open timeline
     ═══════════════════════════════════════════ */

  closeBtn.addEventListener('click', function() { closeWidget(); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen && !isAnimating) { e.preventDefault(); closeWidget(); }
  });

  function closeWidget() {
    if (isAnimating || !isOpen) return;
    isAnimating = true;

    widget.style.transform = '';
    widget.style.bottom = '';
    widget.style.maxHeight = '';

    /* Hide backdrop + unlock body scroll immediately so background reads as released */
    if (backdrop) backdrop.classList.remove('is-visible');
    document.documentElement.classList.remove('quote-modal-open');

    if (!g() || prefersReducedMotion) {
      widget.classList.remove('is-open', 'is-form');
      widget.style.height = '';
      if (openTl) { openTl.kill(); openTl = null; }
      isOpen = false; isAnimating = false;
      pillRevealed = true;
      onRevealScroll();
      if (triggerEl) { triggerEl.focus(); triggerEl = null; }
      return;
    }

    /* If openTl is still valid (no tab switch happened), reverse it — preserves
       the elegant pill-collapse animation. Otherwise build a fresh collapse
       from the widget's current size to the pill. */
    if (openTl) {
      openTl.reverse();
      return;
    }

    /* Fresh collapse — measure current vs pill, then animate */
    var wasForm = widget.classList.contains('is-form');
    var currStyles = getComputedStyle(widget);
    var currentH = widget.offsetHeight;
    var currentW = widget.offsetWidth;
    var currentBot = parseFloat(currStyles.bottom);
    var currentRight = parseFloat(currStyles.right);

    widget.classList.remove('is-open', 'is-form');
    var pillStyles = getComputedStyle(widget);
    var pillW = widget.offsetWidth;
    var pillH = widget.offsetHeight;
    var pillBot = parseFloat(pillStyles.bottom);
    var pillRight = parseFloat(pillStyles.right);

    widget.classList.add('is-open');
    if (wasForm) widget.classList.add('is-form');

    gsap.set(widget, {
      width: currentW, height: currentH,
      bottom: currentBot, right: currentRight,
      borderRadius: 12, overflow: 'hidden',
    });

    gsap.to(topbar, { opacity: 0, duration: 0.2 });
    if (wasForm) gsap.to(formView, { opacity: 0, duration: 0.25 });
    else gsap.to(content, { opacity: 0, duration: 0.25 });

    gsap.to(widget, {
      width: pillW, height: pillH,
      bottom: pillBot, right: pillRight,
      duration: 0.45, ease: 'power2.inOut',
      delay: 0.05,
      onComplete: function() {
        widget.classList.remove('is-open', 'is-form');
        gsap.set(widget, { clearProps: 'all' });
        gsap.set(topbar, { clearProps: 'all' });
        gsap.set(formView, { clearProps: 'all' });
        gsap.set(content, { clearProps: 'all' });
        gsap.set(pillLabel, { clearProps: 'all' });
        isOpen = false; isAnimating = false;
        /* clearProps made the pill visible again — re-check scroll so it hides
           if we closed while still over the hero. */
        pillRevealed = true;
        onRevealScroll();
        if (triggerEl) { triggerEl.focus(); triggerEl = null; }
      },
    });
  }

  if (backdrop) backdrop.addEventListener('click', closeWidget);

  /* ── Reveal on scroll ──
     The sticky CTA stays hidden over the hero and only appears once the visitor
     has scrolled past the first viewport (≈ below the hero). It always stays
     visible while the modal is open, regardless of scroll position. */
  var pillRevealed = false;

  function setPillHidden() {
    if (g()) gsap.set(widget, { autoAlpha: 0, y: 20 });
    else { widget.style.opacity = '0'; widget.style.visibility = 'hidden'; }
  }

  function revealPill() {
    if (pillRevealed) return;
    pillRevealed = true;
    if (entranceTween) { entranceTween.kill(); entranceTween = null; }
    if (g() && !prefersReducedMotion) {
      entranceTween = gsap.to(widget, {
        autoAlpha: 1, y: 0, duration: 0.5, ease: 'power2.out',
        onComplete: function() { entranceTween = null; },
      });
    } else if (g()) {
      gsap.set(widget, { autoAlpha: 1, y: 0 });
    } else {
      widget.style.opacity = '1'; widget.style.visibility = 'visible';
    }
  }

  function concealPill() {
    if (!pillRevealed || isOpen) return;
    pillRevealed = false;
    if (entranceTween) { entranceTween.kill(); entranceTween = null; }
    if (g() && !prefersReducedMotion) {
      entranceTween = gsap.to(widget, {
        autoAlpha: 0, y: 20, duration: 0.3, ease: 'power2.in',
        onComplete: function() { entranceTween = null; },
      });
    } else {
      setPillHidden();
    }
  }

  var revealTicking = false;
  var footerInView = false;
  var processSections = document.querySelectorAll('.process-wrapper');

  /* A 3-step process section is a tall, multi-viewport scroll track, so an
     IntersectionObserver on it is finicky. Instead, each scroll frame, just
     measure it: is it filling a meaningful slice of the screen right now? */
  function processOnScreen() {
    for (var i = 0; i < processSections.length; i++) {
      var r = processSections[i].getBoundingClientRect();
      if (r.top < window.innerHeight * 0.85 && r.bottom > window.innerHeight * 0.15) return true;
    }
    return false;
  }

  function onRevealScroll() {
    if (revealTicking) return;
    revealTicking = true;
    requestAnimationFrame(function() {
      revealTicking = false;
      if (isOpen) return;
      /* Hidden over the hero (first half-viewport), while a 3-step process
         section owns the screen (full attention on it), and once the footer
         comes into view (never overlaps it). Shown in between. */
      if (footerInView || window.scrollY < window.innerHeight * 0.5 || processOnScreen()) concealPill();
      else revealPill();
    });
  }

  setPillHidden();
  window.addEventListener('scroll', onRevealScroll, { passive: true });
  onRevealScroll();

  /* Hide the sticky CTA while the footer is on screen; re-show on scroll up. */
  var footerEl = document.querySelector('.footer');
  if (footerEl && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      footerInView = entries[0].isIntersecting;
      onRevealScroll();
    }, { threshold: 0 }).observe(footerEl);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-page"]) return;
  try {
    
  var grid = document.getElementById('reviews-grid');
  var loadBtn = document.getElementById('reviews-load-btn');
  var loadWrap = document.getElementById('reviews-load-more');
  if (!grid || !loadBtn) return;

  var BATCH = 8;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  loadBtn.addEventListener('click', function() {
    var hidden = grid.querySelectorAll('[data-reviews-hidden]');
    var count = Math.min(BATCH, hidden.length);

    for (var i = 0; i < count; i++) {
      hidden[i].hidden = false;
      hidden[i].removeAttribute('data-reviews-hidden');

      if (typeof gsap !== 'undefined' && !prefersReducedMotion) {
        gsap.from(hidden[i], { autoAlpha: 0, y: 16, duration: 0.4, delay: i * 0.05, ease: 'power2.out' });
      }
    }

    /* Hide button when all reviews are visible */
    var remaining = grid.querySelectorAll('[data-reviews-hidden]');
    if (!remaining.length && loadWrap) {
      loadWrap.style.display = 'none';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-overlay"]) return;
  try {
    
  (function () {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;

    var backdrop = document.querySelector('[data-search-backdrop]');
    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-search-results]');
    var form = overlay.querySelector('[data-search-form]');
    var predictiveUrl = overlay.getAttribute('data-predictive-url') || '/search/suggest';
    var searchUrl = overlay.getAttribute('data-search-url') || '/search';
    var lastFocus = null;
    var debounceTimer = null;
    var controller = null;

    function open() {
      lastFocus = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.classList.add('is-visible');
      window.fkScrollLock.lock('search');
      setTimeout(function () { input.focus(); }, 50);
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      if (backdrop) backdrop.classList.remove('is-visible');
      window.fkScrollLock.unlock('search');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function runSearch(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = predictiveUrl
        + '?q=' + encodeURIComponent(q)
        + '&section_id=search-overlay'
        + '&resources[type]=product,page,article'
        + '&resources[limit]=6';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-search-results]');
          if (fresh) results.innerHTML = fresh.innerHTML;
        })
        .catch(function () { /* aborted or network error — ignore */ });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < 2) { results.innerHTML = ''; return; }
      debounceTimer = setTimeout(function () { runSearch(q); }, 250);
    });

    /* Enter → full search results page */
    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); return; }
      /* let the native GET submit to searchUrl?q=... */
    });

    overlay.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-close]')) close();
    });
    if (backdrop) backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-open="search"]');
      if (trigger) { e.preventDefault(); open(); }
    });

    window.fkSearch = { open: open, close: close };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showcase"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.showcase__cards-wrapper').forEach(function(wrapper) {
      var track = wrapper.querySelector('.showcase__cards');
      var prevBtn = wrapper.querySelector('.showcase__cards-nav-btn--prev');
      var nextBtn = wrapper.querySelector('.showcase__cards-nav-btn--next');

      if (!track || !prevBtn || !nextBtn) return;

      var item = track.querySelector('.showcase__card');
      var scrollAmount = item ? item.offsetWidth + 20 : 400;

      prevBtn.addEventListener('click', function() {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function() {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      /* Disable arrows at the start/end so it's clear there's no more to scroll. */
      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
      }

      var arrowsRaf = null;
      track.addEventListener('scroll', function() {
        if (arrowsRaf) return;
        arrowsRaf = requestAnimationFrame(function() {
          updateArrows();
          arrowsRaf = null;
        });
      }, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      /* Mouse-follow "View X" cursor over the cards. */
      var cursor = wrapper.querySelector('.showcase__cursor');
      var cursorText = cursor ? cursor.querySelector('[data-cursor-text]') : null;
      var cards = wrapper.querySelectorAll('.showcase__card');
      if (!cursor || !cursorText || prefersReducedMotion) return;

      var targetX = 0, targetY = 0, currentX = 0, currentY = 0;
      var rafId = null, isOver = false, hideTimeout = null;
      var currentLabel = '', swapTl = null;

      function animate() {
        currentX += (targetX - currentX) * 0.15;
        currentY += (targetY - currentY) * 0.15;
        cursor.style.left = currentX + 'px';
        cursor.style.top = currentY + 'px';
        rafId = requestAnimationFrame(animate);
      }

      function show() {
        clearTimeout(hideTimeout);
        isOver = true;
        cursor.classList.add('is-visible');
        if (!rafId) rafId = requestAnimationFrame(animate);
      }

      function hide() {
        isOver = false;
        hideTimeout = setTimeout(function() {
          if (!isOver) {
            cursor.classList.remove('is-visible');
            if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
          }
        }, 50);
      }

      /* Swap the label with a GSAP timeline: the old text rolls up + fades out,
         swaps while invisible (no flicker), then the new text rolls up from
         below + fades in while the pill's width glides to fit it. */
      function setLabel(label) {
        label = label || '';
        var GSAP = window.gsap;

        /* Appearing fresh, or no GSAP → set directly, no swap animation. */
        if (!GSAP || !cursor.classList.contains('is-visible')) {
          if (swapTl) { swapTl.kill(); swapTl = null; }
          currentLabel = label;
          cursorText.textContent = label;
          if (GSAP) {
            GSAP.set(cursorText, { opacity: 1, y: 0 });
            GSAP.set(cursor, { clearProps: 'width' });
          }
          return;
        }

        if (label === currentLabel) return;
        currentLabel = label;

        var startWidth = cursor.offsetWidth;
        if (swapTl) swapTl.kill();
        swapTl = GSAP.timeline();
        swapTl
          .to(cursorText, { opacity: 0, y: -7, duration: 0.18, ease: 'power2.in' })
          .add(function () {
            cursorText.textContent = label;
            GSAP.set(cursor, { width: 'auto' });
            var endWidth = cursor.offsetWidth;
            GSAP.set(cursor, { width: startWidth });
            GSAP.to(cursor, { width: endWidth, duration: 0.45, ease: 'power3.out' });
            GSAP.set(cursorText, { y: 7 });
          })
          .to(cursorText, { opacity: 1, y: 0, duration: 0.3, ease: 'power3.out' });
      }

      cards.forEach(function(card) {
        card.addEventListener('mouseenter', function(e) {
          setLabel(card.getAttribute('data-view-label'));
          if (!rafId) { currentX = e.clientX; currentY = e.clientY; }
          targetX = e.clientX;
          targetY = e.clientY;
          show();
        });
        card.addEventListener('mousemove', function(e) {
          targetX = e.clientX;
          targetY = e.clientY;
        });
        card.addEventListener('mouseleave', hide);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-approach"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.studio-approach__stats').forEach(function(statsContainer) {
      var numbers = statsContainer.querySelectorAll('[data-count]');
      var hasAnimated = false;

      if (prefersReducedMotion || numbers.length === 0) return;

      function parseNumber(str) {
        var suffix = str.replace(/[\d,.]/g, '');
        var num = parseInt(str.replace(/[^\d]/g, ''), 10);
        var hasComma = str.indexOf(',') !== -1;
        return { value: num, suffix: suffix, hasComma: hasComma };
      }

      function formatNumber(num, useComma) {
        if (!useComma) return num.toString();
        return num.toLocaleString('en-US');
      }

      function easeOutQuart(t) {
        return 1 - Math.pow(1 - t, 4);
      }

      function animateNumber(el, parsed) {
        var start = Math.round(parsed.value * 0.8);
        var end = parsed.value;
        var duration = 2000;
        var startTime = null;

        function tick(timestamp) {
          if (!startTime) startTime = timestamp;
          var elapsed = timestamp - startTime;
          var progress = Math.min(elapsed / duration, 1);
          var eased = easeOutQuart(progress);
          var current = Math.round(start + (end - start) * eased);

          el.textContent = formatNumber(current, parsed.hasComma) + parsed.suffix;

          if (progress < 1) {
            requestAnimationFrame(tick);
          }
        }

        requestAnimationFrame(tick);
      }

      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting && !hasAnimated) {
          hasAnimated = true;
          numbers.forEach(function(el) {
            var parsed = parseNumber(el.getAttribute('data-count'));
            if (isNaN(parsed.value)) return;
            animateNumber(el, parsed);
          });
          observer.disconnect();
        }
      }, { threshold: 0.3 });

      observer.observe(statsContainer);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-shots"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.studio-shots').forEach(function(section) {
      var track = section.querySelector('.studio-shots__track');
      var prevBtn = section.querySelector('.studio-shots__nav-btn--prev');
      var nextBtn = section.querySelector('.studio-shots__nav-btn--next');

      if (!track) return;

      var centerOffset = (track.scrollWidth - track.clientWidth) / 2;
      track.scrollLeft = centerOffset;

      var autoScrollSpeed = 0.5;
      var autoScrollId = null;
      var isUserScrolling = false;
      var userScrollTimeout = null;

      function startAutoScroll() {
        if (prefersReducedMotion || autoScrollId) return;

        autoScrollId = requestAnimationFrame(function tick() {
          if (!isUserScrolling) {
            track.scrollLeft += autoScrollSpeed;

            if (track.scrollLeft >= track.scrollWidth - track.clientWidth) {
              track.scrollLeft = 0;
            }
          }
          autoScrollId = requestAnimationFrame(tick);
        });
      }

      function stopAutoScroll() {
        if (autoScrollId) {
          cancelAnimationFrame(autoScrollId);
          autoScrollId = null;
        }
      }

      function pauseAutoScroll() {
        isUserScrolling = true;
        clearTimeout(userScrollTimeout);
        userScrollTimeout = setTimeout(function() {
          isUserScrolling = false;
        }, 3000);
      }

      track.addEventListener('pointerdown', pauseAutoScroll);
      track.addEventListener('wheel', pauseAutoScroll, { passive: true });

      if (prevBtn && nextBtn) {
        var item = track.querySelector('.studio-shots__item');
        var scrollAmount = item ? item.offsetWidth + 20 : 400;

        prevBtn.addEventListener('click', function() {
          pauseAutoScroll();
          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', function() {
          pauseAutoScroll();
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      }

      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          startAutoScroll();
        } else {
          stopAutoScroll();
        }
      }, { threshold: 0.2 });

      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-team"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.studio-team__grid').forEach(function(grid) {
      var isDown = false;
      var startX = 0;
      var scrollStart = 0;
      var hasDragged = false;
      var lastX = 0;
      var lastTime = 0;
      var velocity = 0;
      var momentumId = null;

      function stopMomentum() {
        if (momentumId) {
          cancelAnimationFrame(momentumId);
          momentumId = null;
        }
      }

      function applyMomentum() {
        if (Math.abs(velocity) < 0.5) {
          momentumId = null;
          return;
        }
        grid.scrollLeft += velocity;
        velocity *= 0.95;
        momentumId = requestAnimationFrame(applyMomentum);
      }

      grid.addEventListener('pointerdown', function(e) {
        isDown = true;
        hasDragged = false;
        startX = e.pageX;
        lastX = e.pageX;
        lastTime = Date.now();
        velocity = 0;
        scrollStart = grid.scrollLeft;
        stopMomentum();
        grid.classList.add('is-dragging');
        grid.setPointerCapture(e.pointerId);
      });

      grid.addEventListener('pointermove', function(e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        var now = Date.now();
        var dt = now - lastTime;

        if (Math.abs(dx) > 5) {
          hasDragged = true;
        }

        if (dt > 0) {
          velocity = (lastX - e.pageX) / dt * 16;
        }

        lastX = e.pageX;
        lastTime = now;
        grid.scrollLeft = scrollStart - dx;
      });

      grid.addEventListener('pointerup', function(e) {
        isDown = false;
        grid.classList.remove('is-dragging');
        grid.releasePointerCapture(e.pointerId);

        if (Math.abs(velocity) > 1) {
          momentumId = requestAnimationFrame(applyMomentum);
        }
      });

      grid.addEventListener('click', function(e) {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
